//
// Copyright (c) 2020-2026, NVIDIA CORPORATION.  All rights reserved.
//
// NVIDIA CORPORATION and its licensors retain all intellectual property
// and proprietary rights in and to this software, related documentation
// and any modifications thereto.  Any use, reproduction, disclosure or
// distribution of this software and related documentation without an express
// license agreement from NVIDIA CORPORATION is strictly prohibited.

///////////////////////////////////////////////////////////////////////////////
//
//        THIS FILE IS GENERATED FROM EVENT SCHEMA GFN_Client v35.7, DO NOT MODIFY IT
//        Please use https://sms.gxt.nvidia.com/ to update the schema
//        and generate the code.
//
///////////////////////////////////////////////////////////////////////////////

/////// Type Declarations ////////
type String = string;
type HTTPStatusCode = number;
type Uint16 = number;
type VersionString = string;
type URLString = string;
type Float = number;
type Int32 = number;
type Uint32 = number;
type InfoString = string;
type IdString = string;
type ErrorMessage = string;
type Counter = number;
type Double = number;
type NetworkErrorCode = string;

/////// Enum Declarations ////////
export enum ConsentLevel {
    Full = 'Full',
    None = 'None'
}

export enum GdprLevel {
    Functional = 'functional',
    Technical = 'technical',
    Behavioral = 'behavioral'
}

export enum Personalization {
    Anonymous = 'anonymous',
    DeviceOnly = 'deviceOnly',
    DevicePreferred = 'devicePreferred',
    UserPreferred = 'userPreferred',
    UserRequired = 'userRequired'
}

export enum HTTPVerb {
    OTHER = 'OTHER',
    HEAD = 'HEAD',
    DELETE = 'DELETE',
    POST = 'POST',
    GET = 'GET',
    CONNECT = 'CONNECT',
    OPTIONS = 'OPTIONS',
    PUT = 'PUT',
    WS = 'WS'
}

export enum PushNotificationMessageType {
    PRODUCT_CHANGE = 'PRODUCT_CHANGE',
    ASSET_CHANGE = 'ASSET_CHANGE',
    SESSION_CHANGE = 'SESSION_CHANGE',
    LAYOUT_CHANGE = 'LAYOUT_CHANGE',
    GSWS_SYNC = 'GSWS_SYNC',
    SECTION_CHANGE = 'SECTION_CHANGE',
    LINKEDACCOUNT_CHANGE = 'LINKEDACCOUNT_CHANGE',
    APP_CHANGE = 'APP_CHANGE',
    SERVER_INFO_SYNC = 'SERVER_INFO_SYNC',
    CONFIGURATION_CHANGE = 'CONFIGURATION_CHANGE',
    SUBSCRIPTION_CHANGE = 'SUBSCRIPTION_CHANGE',
    UNKNOWN = 'UNKNOWN',
    PATCHING_EVENT = 'PATCHING_EVENT',
    KV_STORE_CHANGE = 'KV_STORE_CHANGE',
    LIBRARY_CHANGE = 'LIBRARY_CHANGE',
    PLATFORM_SYNC_CHANGE = 'PLATFORM_SYNC_CHANGE',
    CAMPAIGN_CHANGE = 'CAMPAIGN_CHANGE',
    FAVORITES_CHANGE = 'FAVORITES_CHANGE'
}

export enum ContentType {
    Video = 'Video',
    Image = 'Image',
    None = 'None'
}

export enum GallerySortType {
    Oldest = 'Oldest',
    AtoZ = 'AtoZ',
    Newest = 'Newest',
    ZtoA = 'ZtoA'
}

export enum GameCampaignsUpdateTrigger {
    AppsRefresh = 'AppsRefresh',
    PanelRefresh = 'PanelRefresh',
    CampaignsRefresh = 'CampaignsRefresh',
    TimerRefresh = 'TimerRefresh'
}

export enum UDSTriggerSource {
    EndOfSession = 'EndOfSession',
    Mall = 'Mall',
    Notification = 'Notification'
}

export enum GalleryFilterType {
    Highlights = 'Highlights',
    Game = 'Game',
    Media = 'Media'
}

export enum DragItemType {
    GameShortcutUrl = 'GameShortcutUrl'
}

export enum UserAction {
    AddDesktopShortcut = 'AddDesktopShortcut',
    LaunchGame = 'LaunchGame',
    NesAutoAuthorization = 'NesAutoAuthorization',
    LoginWithJarvisOAuth = 'LoginWithJarvisOAuth',
    LoginWithFacebook = 'LoginWithFacebook',
    NesGetCompleteLayouts = 'NesGetCompleteLayouts',
    LoginWithAffiliate = 'LoginWithAffiliate',
    LoginWithGoogle = 'LoginWithGoogle',
    Continue = 'Continue',
    ManageECommerceSubscription = 'ManageECommerceSubscription',
    UninstallGame = 'UninstallGame',
    LoginWithOther = 'LoginWithOther',
    AddGameToLibrary = 'AddGameToLibrary',
    Resend = 'Resend',
    LoginWithStarfleet = 'LoginWithStarfleet',
    ServiceWorkerActivation = 'ServiceWorkerActivation',
    SilentLoginDirectLaunch = 'SilentLoginDirectLaunch',
    LoginviaLoginHint = 'LoginviaLoginHint',
    SilentLoginRedirectFromDMO = 'SilentLoginRedirectFromDMO',
    AutoEntitle = 'AutoEntitle',
    LoginWithStarfleetViaLoginWall = 'LoginWithStarfleetViaLoginWall',
    IapEntitlement = 'IapEntitlement'
}

export enum OriginalServiceName {
    Jarvis = 'Jarvis',
    Gfc = 'Gfc',
    Lcars = 'Lcars',
    Grid = 'Grid',
    Cms = 'Cms',
    Aem = 'Aem',
    Survey = 'Survey',
    DR = 'DR',
    RemoteConfig = 'RemoteConfig',
    Starfleet = 'Starfleet',
    Other = 'Other',
    Rating = 'Rating',
    Gfwsl = 'Gfwsl',
    KVStore = 'KVStore',
    GxTarget = 'GxTarget',
    NES = 'NES',
    ALS = 'ALS',
    AwsS3 = 'AwsS3',
    PNS = 'PNS',
    UAS = 'UAS',
    UDS = 'UDS',
    UCP = 'UCP',
    DMOBackend = 'DMOBackend'
}

export enum SurveyTriggerType {
    COMMUNICATION_BANNER = 'COMMUNICATION_BANNER',
    UXTEST_BANNER = 'UXTEST_BANNER',
    SURVEY_BANNER = 'SURVEY_BANNER',
    POST_GAME = 'POST_GAME',
    FEEDBACK = 'FEEDBACK',
    NOTIFICATION_BANNER = 'NOTIFICATION_BANNER'
}

export enum LayoutPipelineStage {
    NA = 'NA',
    EmptyLayout = 'EmptyLayout',
    AppsListFetch = 'AppsListFetch',
    VpcId = 'VpcId',
    Unknown = 'Unknown',
    SessionToken = 'SessionToken',
    DelegateTokenFetch = 'DelegateTokenFetch',
    LayoutFetch = 'LayoutFetch',
    OfflineNoCache = 'OfflineNoCache',
    DiskCache = 'DiskCache',
    AppMetadataFetch = 'AppMetadataFetch'
}

export enum NetworkTestUIResult {
    Passed = 'Passed',
    Unknown = 'Unknown',
    LbrDone = 'LbrDone',
    Skipped = 'Skipped',
    DialogShown = 'DialogShown'
}

export enum CaptureAction {
    InstantReplaySaved = 'InstantReplaySaved',
    TurnOffInstantReplay = 'TurnOffInstantReplay',
    StopAndSaveManualCapture = 'StopAndSaveManualCapture',
    StartManualCapture = 'StartManualCapture',
    TurnOnInstantReplay = 'TurnOnInstantReplay',
    ScreenshotSaved = 'ScreenshotSaved'
}

export enum AutoUpdateErrorCategory {
    IO = 'IO',
    Network = 'Network',
    General = 'General',
    JSON = 'JSON',
    None = 'None',
    File = 'File',
    Optimization = 'Optimization',
    IPC = 'IPC'
}

export enum APIStatus {
    Success = 'Success',
    Failure = 'Failure'
}

export enum GameResumeType {
    AutoResume = 'AutoResume',
    DeviceTransition = 'DeviceTransition',
    None = 'None'
}

export enum ServiceSubUseCaseName {
    GetFreestyleFeature = 'GetFreestyleFeature',
    SendUsabilityStudyResponse = 'SendUsabilityStudyResponse',
    GetDeeplinkSupport = 'GetDeeplinkSupport',
    GetCloudSearch = 'GetCloudSearch',
    GetSurveyFeature = 'GetSurveyFeature',
    GetLayoutRefreshInterval = 'GetLayoutRefreshInterval',
    GetUsabilityStudy = 'GetUsabilityStudy',
    GetIgoSupportOnBrowserClient = 'GetIgoSupportOnBrowserClient',
    GetECommerceFeature = 'GetECommerceFeature',
    GetKeyboardLayout = 'GetKeyboardLayout',
    GetAutohighlightFeature = 'GetAutohighlightFeature',
    GetStarfleetPhase1 = 'GetStarfleetPhase1',
    GetStarfleetPhase2 = 'GetStarfleetPhase2',
    GetQueueETAConfig = 'GetQueueETAConfig',
    GetUpsellMessage = 'GetUpsellMessage',
    GetAllCloudVariables = 'GetAllCloudVariables',
    GetBrowserClientCanary = 'GetBrowserClientCanary',
    GetReservedSKUEnabled = 'GetReservedSKUEnabled',
    GetReservedSKUIBetaFlag = 'GetReservedSKUIBetaFlag',
    GetAnselFeature = 'GetAnselFeature',
    GetGfnBroadcastFeature = 'GetGfnBroadcastFeature',
    GetKBLayoutsConfig = 'GetKBLayoutsConfig',
    GetClipboardPasteConfig = 'GetClipboardPasteConfig',
    GetPathToPurchaseConfig = 'GetPathToPurchaseConfig',
    GetEnableRemoteConfigOnGXT = 'GetEnableRemoteConfigOnGXT',
    GetPunctualUIConfig = 'GetPunctualUIConfig',
    GetGameOwnershipABConfig = 'GetGameOwnershipABConfig',
    GetEnableBrowserIGSS = 'GetEnableBrowserIGSS',
    GetClientIMESupportedConfig = 'GetClientIMESupportedConfig',
    GetGameLaunchUniversalConfig = 'GetGameLaunchUniversalConfig',
    Other = 'Other'
}

export enum LBRPolicy {
    FingerprintChanged = 'FingerprintChanged',
    ZoneListEmpty = 'ZoneListEmpty',
    PolicyCheckFailed = 'PolicyCheckFailed',
    Manual = 'Manual',
    CachedZoneNotStored = 'CachedZoneNotStored',
    ServerInfoFailed = 'ServerInfoFailed',
    CachedZoneNotAvailable = 'CachedZoneNotAvailable',
    NewZonesAdded = 'NewZonesAdded'
}

export enum AudioErrorType {
    AUDIO_ERROR_OTHER = 'AUDIO_ERROR_OTHER',
    AUDIO_ERROR_PLATFORM = 'AUDIO_ERROR_PLATFORM',
    AUDIO_ERROR_NVSC = 'AUDIO_ERROR_NVSC'
}

export enum StorageType {
    Unknown = 'Unknown',
    Internal = 'Internal',
    Network = 'Network',
    External = 'External'
}

export enum DialogExitType {
    App_Exit = 'App_Exit',
    Dialog_Closed = 'Dialog_Closed',
    Goto_Settings = 'Goto_Settings',
    Continue_Login = 'Continue_Login',
    Proceed_Connect = 'Proceed_Connect',
    Paste_Confirmation = 'Paste_Confirmation',
    Continue_Play_Anyway = 'Continue_Play_Anyway',
    Continue_Add_Playtime = 'Continue_Add_Playtime',
    Continue_To_Game_Store = 'Continue_To_Game_Store'
}

export enum PopUpDialogType {
    Release_Highlights = 'Release_Highlights',
    Account_Link_Required = 'Account_Link_Required',
    Account_Link_Expired = 'Account_Link_Expired',
    Account_Link_Expires_Today = 'Account_Link_Expires_Today',
    Account_Link_Expires_Soon = 'Account_Link_Expires_Soon',
    Scheduled_Maintenance_Warning = 'Scheduled_Maintenance_Warning',
    Unsupported_Browser_Or_Platform_Load = 'Unsupported_Browser_Or_Platform_Load',
    Unsupported_Browser_Or_Platform_Login = 'Unsupported_Browser_Or_Platform_Login',
    Unsupported_Browser_Or_Platform_Game_Launch = 'Unsupported_Browser_Or_Platform_Game_Launch',
    InStream_Paste_Gesture_Dialog = 'InStream_Paste_Gesture_Dialog',
    Playtime_Not_Added = 'Playtime_Not_Added',
    Low_State_Game_Launch = 'Low_State_Game_Launch',
    Limited_State_Game_Launch = 'Limited_State_Game_Launch',
    Loading_Screen_Upgrade = 'Loading_Screen_Upgrade',
    Loading_Screen_Get_Day_Pass = 'Loading_Screen_Get_Day_Pass',
    Loading_Screen_Add_Playtime = 'Loading_Screen_Add_Playtime',
    Game_Launch_Unplayable_Error = 'Game_Launch_Unplayable_Error',
    Buy_Protection_Information = 'Buy_Protection_Information',
    Update_Membership = 'Update_Membership',
    Add_Playtime = 'Add_Playtime',
    Upgrade_Storage = 'Upgrade_Storage',
    Storage_Not_Updated = 'Storage_Not_Updated',
    Storage_And_Membership_Updated = 'Storage_And_Membership_Updated',
    Mandatory_Plugin_Error = 'Mandatory_Plugin_Error',
    Optional_Plugin_Error = 'Optional_Plugin_Error',
    Iap_Restore_Checking = 'Iap_Restore_Checking',
    Iap_Restore_No_Purchases_Found = 'Iap_Restore_No_Purchases_Found',
    Iap_Restore_Purchase_Restored = 'Iap_Restore_Purchase_Restored',
    Iap_Restore_Switch_Account_Required = 'Iap_Restore_Switch_Account_Required',
    Iap_Restore_Failed = 'Iap_Restore_Failed',
    Iap_Payment_Verify_Pending = 'Iap_Payment_Verify_Pending',
    Iap_Payment_Failed = 'Iap_Payment_Failed',
    Iap_Memberships_Unavailable = 'Iap_Memberships_Unavailable',
    Iap_Matrix_Load_Failed = 'Iap_Matrix_Load_Failed',
    Iap_Payment_Overview = 'Iap_Payment_Overview',
    Iap_Downgrade_Summary = 'Iap_Downgrade_Summary',
    Iap_Payment_Confirmation = 'Iap_Payment_Confirmation',
    Unknown = 'Unknown'
}

export enum DisplayProfiles {
    NVB_PROFILE_ROAMING_720P_30FPS = 'NVB_PROFILE_ROAMING_720P_30FPS',
    NVB_PROFILE_GAMING_1080P_60FPS = 'NVB_PROFILE_GAMING_1080P_60FPS',
    NT_1280_800_60 = 'NT_1280_800_60',
    NVB_PROFILE_PROFESSIONAL = 'NVB_PROFILE_PROFESSIONAL',
    NVB_PROFILE_GAMING_720P_30FPS = 'NVB_PROFILE_GAMING_720P_30FPS',
    NT_1920_1200_60 = 'NT_1920_1200_60',
    NT_1920_1200_30 = 'NT_1920_1200_30',
    NT_1366_768_30 = 'NT_1366_768_30',
    NT_1366_768_60 = 'NT_1366_768_60',
    NT_1680_1050_30 = 'NT_1680_1050_30',
    NT_1280_800_30 = 'NT_1280_800_30',
    NT_1440_900_30 = 'NT_1440_900_30',
    NT_1680_1050_60 = 'NT_1680_1050_60',
    NVB_PROFILE_GAMING = 'NVB_PROFILE_GAMING',
    NVB_PROFILE_ROAMING_720P_60FPS = 'NVB_PROFILE_ROAMING_720P_60FPS',
    NT_1440_900_60 = 'NT_1440_900_60',
    NVB_PROFILE_GAMING_720P_60FPS = 'NVB_PROFILE_GAMING_720P_60FPS',
    NVB_PROFILE_GAMING_1080P_30FPS = 'NVB_PROFILE_GAMING_1080P_30FPS',
    NVB_PROFILE_DEFAULT = 'NVB_PROFILE_DEFAULT'
}

export enum GameSyncStatus {
    Nvidia_Access_Denied = 'Nvidia_Access_Denied',
    Unknown = 'Unknown',
    Rate_Limited = 'Rate_Limited',
    Platform_Access_Denied = 'Platform_Access_Denied',
    Platform_Profile_Denied = 'Platform_Profile_Denied',
    Success = 'Success',
    Sync_Failed = 'Sync_Failed',
    Sync_Denied = 'Sync_Denied',
    Profile_Not_Created = 'Profile_Not_Created',
    Sync_Success = 'Sync_Success'
}

export enum SurveyStatus {
    DismissManual = 'DismissManual',
    Completed = 'Completed',
    Notify = 'Notify',
    DismissAppExit = 'DismissAppExit',
    DismissLogout = 'DismissLogout',
    DismissSleep = 'DismissSleep',
    DismissTimeout = 'DismissTimeout',
    Participate = 'Participate',
    DismissManualPostMinimize = 'DismissManualPostMinimize',
    NotifyPostMinimize = 'NotifyPostMinimize',
    ParticpatePostMinimize = 'ParticpatePostMinimize',
    Minimized = 'Minimized',
    Deferred = 'Deferred',
    LearnMoreClicked = 'LearnMoreClicked',
    SubmissionErrored = 'SubmissionErrored'
}

export enum HighlightsPermissionSource {
    AlreadyOn = 'AlreadyOn',
    AlreadyOff = 'AlreadyOff',
    Initial = 'Initial',
    Settings = 'Settings'
}

export enum ClientVariantType {
    Dev = 'Dev',
    Release = 'Release',
    IBeta = 'IBeta',
    Autoplay = 'Autoplay'
}

export enum GalleryMediaType {
    Video = 'Video',
    Image = 'Image'
}

export enum AnselScreenshotType {
    SphericalPanorama = 'SphericalPanorama',
    StereoRegular = 'StereoRegular',
    Regular = 'Regular',
    HighRes = 'HighRes',
    StereoSphericalPanorama = 'StereoSphericalPanorama'
}

export enum ClientType {
    StreamingClient = 'StreamingClient',
    MallClient = 'MallClient',
    StoreLibrary = 'StoreLibrary',
    Unknown = 'Unknown',
    BackgroundAgent = 'BackgroundAgent',
    IGO = 'IGO',
    VegaShellApp = 'VegaShellApp'
}

export enum OobeConsentType {
    UserConsented = 'UserConsented',
    NotShown = 'NotShown',
    UserDidNotConsent = 'UserDidNotConsent'
}

export enum VSyncMode {
    Adaptive = 'Adaptive',
    Off = 'Off',
    On = 'On'
}

export enum ProcessType {
    PLUGIN_CONTAINER = 'PLUGIN_CONTAINER',
    MALL_UI = 'MALL_UI',
    RELIABILITY_MONITOR = 'RELIABILITY_MONITOR',
    STREAMER_UI = 'STREAMER_UI',
    UNKNOWN = 'UNKNOWN'
}

export enum AnselFreestyleFailureType {
    AnselFreestyleAlreadyDisabled = 'AnselFreestyleAlreadyDisabled',
    AnselFreestyleMenuLaunchError = 'AnselFreestyleMenuLaunchError',
    AnselFreestyleGeneralFailure = 'AnselFreestyleGeneralFailure',
    AnselFreestyleAlreadyEnabled = 'AnselFreestyleAlreadyEnabled',
    AnselPermissionDenied = 'AnselPermissionDenied',
    AnselFreestyleAlreadySet = 'AnselFreestyleAlreadySet',
    AnselNoSpaceLeft = 'AnselNoSpaceLeft',
    AnselOutOfRange = 'AnselOutOfRange',
    AnselFailedToStart = 'AnselFailedToStart',
    AnselFreestyleIncompatibleVersion = 'AnselFreestyleIncompatibleVersion',
    AnselFreestyleNoResponse = 'AnselFreestyleNoResponse',
    AnselFreestyleAppFatalError = 'AnselFreestyleAppFatalError',
    AnselFreestyleUnsupportedGameError = 'AnselFreestyleUnsupportedGameError',
    AnselInvalidRequest = 'AnselInvalidRequest',
    AnselFreestyleAppNonFatalError = 'AnselFreestyleAppNonFatalError'
}

export enum AnselScreenshotState {
    Started = 'Started',
    Failed = 'Failed',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}

export enum SearchType {
    RecentSearchResult = 'RecentSearchResult',
    NewSearchResult = 'NewSearchResult',
    PausedSearch = 'PausedSearch',
    AbandonedSearch = 'AbandonedSearch'
}

export enum ClickItemType {
    UpdBufferTips = 'UpdBufferTips',
    PlatformSelection = 'PlatformSelection',
    PlatformChangeConsent = 'PlatformChangeConsent',
    Redeem = 'Redeem',
    ManualLogout = 'ManualLogout',
    StreamerBackNavigation = 'StreamerBackNavigation',
    Settings = 'Settings',
    NetworkTroubleshooting = 'NetworkTroubleshooting',
    AllGames = 'AllGames',
    JoinGfn = 'JoinGfn',
    AddGameToLibrary = 'AddGameToLibrary',
    ManageMembership = 'ManageMembership',
    ViewMembershipDetails = 'ViewMembershipDetails',
    MarketingMarquee = 'MarketingMarquee',
    ReleaseHighlights = 'ReleaseHighlights',
    ShareGame = 'ShareGame',
    LaunchGame = 'LaunchGame',
    AddGameShortcut = 'AddGameShortcut',
    MyLibrary = 'MyLibrary',
    ViewGameDetails = 'ViewGameDetails',
    UninstallGame = 'UninstallGame',
    AccountManagementSso = 'AccountManagementSso',
    Upgrade = 'Upgrade',
    InvokeSearch = 'InvokeSearch',
    AddBrowserShortcut = 'AddBrowserShortcut',
    AccountMenu = 'AccountMenu',
    OpenClientIME = 'OpenClientIME',
    OpenFeedbackDialog = 'OpenFeedbackDialog',
    OpenOnScreenKeyboard = 'OpenOnScreenKeyboard',
    CloseOnScreenKeyboard = 'CloseOnScreenKeyboard',
    PasteClipboardText = 'PasteClipboardText',
    ShowVirtualGamepad = 'ShowVirtualGamepad',
    ToggleMicrophone = 'ToggleMicrophone',
    ToggleNetworkWarnings = 'ToggleNetworkWarnings',
    QuitGame = 'QuitGame',
    LearnMoreAboutStreamingProfiles = 'LearnMoreAboutStreamingProfiles',
    SeeMore = 'SeeMore',
    FilterTile = 'FilterTile',
    PathToPurchase = 'PathToPurchase',
    PromoCTA = 'PromoCTA',
    Unmute = 'Unmute',
    Mute = 'Mute',
    AddPlaytime = 'AddPlaytime',
    ViewPlaytime = 'ViewPlaytime',
    HowPlaytimeWorksKBA = 'HowPlaytimeWorksKBA',
    LimitedFeaturesKBA = 'LimitedFeaturesKBA',
    GetDayPass = 'GetDayPass',
    AddDayPass = 'AddDayPass',
    RefreshUserSubscription = 'RefreshUserSubscription',
    AddToFavorite = 'AddToFavorite',
    RemoveFromFavorite = 'RemoveFromFavorite',
    ClickedUrl = 'ClickedUrl',
    ChangePreferredGameLanguage = 'ChangePreferredGameLanguage',
    SkuBasedCatalogLearnMoreKBA = 'SkuBasedCatalogLearnMoreKBA',
    VisitSupport = 'VisitSupport',
    MarketingSectionTile = 'MarketingSectionTile',
    Install = 'Install',
    AddStorage = 'AddStorage',
    UpgradeStorage = 'UpgradeStorage',
    LaunchButton = 'LaunchButton',
    StorageDetails = 'StorageDetails',
    StorageReset = 'StorageReset',
    ManageStoreGame = 'ManageStoreGame',
    ConnectAccount = 'ConnectAccount',
    LinkAccounts = 'LinkAccounts',
    DeleteAccount = 'DeleteAccount',
    IapSwitchUser = 'IapSwitchUser'
}

export enum ClickInputSource {
    Keyboard = 'Keyboard',
    Gamepad = 'Gamepad',
    Mouse = 'Mouse',
    Touch = 'Touch',
    Unknown = 'Unknown'
}

export enum HDRStreamingMode {
    OFF = 'OFF',
    HDR = 'HDR',
    HDR10_PLUS_GAMING = 'HDR10_PLUS_GAMING'
}

export enum HID {
    Joystick = 'Joystick',
    Mouse = 'Mouse',
    Unknown = 'Unknown',
    Keyboard = 'Keyboard',
    GamePad = 'GamePad'
}

export enum OscAnselScreenshotFailureType {
    AnselScreenshotNoFailure = 'AnselScreenshotNoFailure',
    AnselScreenshotUnknownFailure = 'AnselScreenshotUnknownFailure',
    AnselScreenshotTimeoutFailure = 'AnselScreenshotTimeoutFailure'
}

export enum UIVariantName {
    StreamerUsedFreeUpsell = 'StreamerUsedFreeUpsell',
    StreamerQueueUpsell = 'StreamerQueueUpsell',
    StreamerNoFreeUpsell = 'StreamerNoFreeUpsell',
    StreamerPostSessionFreeGaaSUpsell = 'StreamerPostSessionFreeGaaSUpsell',
    StreamerPostSessionUpsell = 'StreamerPostSessionUpsell',
    StreamerPostSessionAnonGaaSUpsell = 'StreamerPostSessionAnonGaaSUpsell',
    Standard = 'Standard'
}

export enum SyncCTATileUserAction {
    Clicked = 'Clicked',
    Dismissed = 'Dismissed'
}

export enum BooleanType {
    UNDEFINED = 'UNDEFINED',
    TRUE = 'TRUE',
    FALSE = 'FALSE'
}

export enum SDKCallAction {
    HighlightsGetUserConfig = 'HighlightsGetUserConfig',
    HighlightsConfigure = 'HighlightsConfigure',
    HighlightsGetCount = 'HighlightsGetCount',
    HighlightsOpenGroup = 'HighlightsOpenGroup',
    Connect = 'Connect',
    HighlightsOpenSummary = 'HighlightsOpenSummary',
    HighlightsSaveScreenshot = 'HighlightsSaveScreenshot',
    HighlightsSaveVideo = 'HighlightsSaveVideo',
    Disconnect = 'Disconnect',
    RequestPermissions = 'RequestPermissions',
    HighlightsCloseGroup = 'HighlightsCloseGroup',
    GetLanguage = 'GetLanguage',
    OpsOptimize = 'OpsOptimize',
    Unknown = 'Unknown'
}

export enum NetworkTestErrorReason {
    AUTH_FAILED = 'AUTH_FAILED',
    SESSION_EXIST = 'SESSION_EXIST',
    RETRYABLE_POST_FAILURE = 'RETRYABLE_POST_FAILURE',
    BLOCK_STREAM = 'BLOCK_STREAM',
    WIFI_2_4 = 'WIFI_2_4',
    INVALID_PARAM = 'INVALID_PARAM',
    TEST_IN_PROGRESS = 'TEST_IN_PROGRESS',
    POST_FAILED = 'POST_FAILED',
    NA = 'NA',
    FAILED = 'FAILED',
    INVALID_DATA = 'INVALID_DATA',
    CANCELED = 'CANCELED',
    SETUP_FAILED = 'SETUP_FAILED',
    PacketLoss = 'PacketLoss',
    UNKNOWN = 'UNKNOWN',
    SYN_FAILED = 'SYN_FAILED',
    FIN_FAILED = 'FIN_FAILED',
    CAPACITY_FULL = 'CAPACITY_FULL'
}

export enum UIStateName {
    HotkeySettings = 'HotkeySettings',
    GalleryMain = 'GalleryMain',
    StorageSettings = 'StorageSettings',
    GalleryImagePreview = 'GalleryImagePreview',
    HUDSettings = 'HUDSettings',
    NotificationSettings = 'NotificationSettings',
    MainMenu = 'MainMenu',
    VideoCaptureSettings = 'VideoCaptureSettings',
    Privacy = 'Privacy',
    GalleryVideoPreview = 'GalleryVideoPreview',
    HighlightsSettings = 'HighlightsSettings',
    FolderBrowser = 'FolderBrowser',
    None = 'None',
    Settings = 'Settings',
    System = 'System',
    GfnBroadcast = 'GfnBroadcast',
    General = 'General',
    Gameplay = 'Gameplay',
    Debug = 'Debug'
}

export enum ClientIMEButtonEnum {
    Cancel = 'Cancel',
    Send = 'Send'
}

export enum OpportunityStatus {
    Unknown = 'Unknown',
    NotStarted = 'NotStarted',
    Started = 'Started',
    Completed = 'Completed',
    Canceled = 'Canceled',
    Paused = 'Paused',
    Resumed = 'Resumed',
    Clicked = 'Clicked',
    StateChange = 'StateChange'
}

export enum Orientation {
    Landscape = 'Landscape',
    Portrait = 'Portrait',
    Unknown = 'Unknown'
}

export enum PlatformType {
    Unknown = 'Unknown',
    Windows = 'Windows',
    Mac = 'Mac',
    Android = 'Android',
    Web = 'Web',
    Linux = 'Linux'
}

export enum DeeplinkAction {
    PlayGame = 'PlayGame',
    ViewGame = 'ViewGame',
    None = 'None'
}

export enum ServiceUseCaseName {
    GetServerInformation = 'GetServerInformation',
    JARVIS_Get_User_Token = 'JARVIS_Get_User_Token',
    Image_Retrieval_Tile_Feature = 'Image_Retrieval_Tile_Feature',
    JARVIS_Set_Pin = 'JARVIS_Set_Pin',
    JARVIS_Redeem_Delegate_Token = 'JARVIS_Redeem_Delegate_Token',
    Append_Client_Data = 'Append_Client_Data',
    Get_Client_Settings = 'Get_Client_Settings',
    NES_Cancel_Subscription = 'NES_Cancel_Subscription',
    Get_Client_Data = 'Get_Client_Data',
    GetAppVariants = 'GetAppVariants',
    NES_Update_Subscription = 'NES_Update_Subscription',
    GetAppData = 'GetAppData',
    Layout_Get_Tile_Data = 'Layout_Get_Tile_Data',
    NES_Get_PlayTime = 'NES_Get_PlayTime',
    InitiateDownload = 'InitiateDownload',
    DR_Get_Product = 'DR_Get_Product',
    NES_Install = 'NES_Install',
    NES_Get_Subscriptions = 'NES_Get_Subscriptions',
    NES_Get_Products = 'NES_Get_Products',
    JARVIS_Chain_Session = 'JARVIS_Chain_Session',
    FCM_Checkin = 'FCM_Checkin',
    GetPrivacyPolicy = 'GetPrivacyPolicy',
    NES_Get_Credits = 'NES_Get_Credits',
    JARVIS_Get_Third_Party_Provider_Info = 'JARVIS_Get_Third_Party_Provider_Info',
    FCM_Subscribe = 'FCM_Subscribe',
    FCM_Unregister = 'FCM_Unregister',
    JARVIS_Request_Email_Verify = 'JARVIS_Request_Email_Verify',
    JARVIS_Verify_Pin = 'JARVIS_Verify_Pin',
    GetCloudVariable = 'GetCloudVariable',
    CheckForUpdate = 'CheckForUpdate',
    DR_Put_Cart = 'DR_Put_Cart',
    Get_Client_Token = 'Get_Client_Token',
    FCM_Unsubscribe = 'FCM_Unsubscribe',
    Streaming_GetFeedbackToken = 'Streaming_GetFeedbackToken',
    GetRemoteConfig = 'GetRemoteConfig',
    Get_Release_Highlights = 'Get_Release_Highlights',
    Get_User_Info = 'Get_User_Info',
    PrepareToDownload = 'PrepareToDownload',
    NES_Get_Resource = 'NES_Get_Resource',
    DR_Get_Payment = 'DR_Get_Payment',
    GetFeatureRollout = 'GetFeatureRollout',
    NES_Get_ServiceUrls = 'NES_Get_ServiceUrls',
    JARVIS_Get_Login_Token = 'JARVIS_Get_Login_Token',
    JARVIS_Get_Delegate_Token = 'JARVIS_Get_Delegate_Token',
    Set_Client_Data = 'Set_Client_Data',
    Layout_Get_Section = 'Layout_Get_Section',
    DR_Edit_Payment = 'DR_Edit_Payment',
    FeedbackHead = 'FeedbackHead',
    DR_Empty_Cart = 'DR_Empty_Cart',
    NES_Get_Apps = 'NES_Get_Apps',
    DR_Get_Orders = 'DR_Get_Orders',
    FCM_Register = 'FCM_Register',
    DR_Apply_Shopper = 'DR_Apply_Shopper',
    DR_Get_Token = 'DR_Get_Token',
    GetTermsAndConditions = 'GetTermsAndConditions',
    GetSurvey = 'GetSurvey',
    Layout_Get_Sections = 'Layout_Get_Sections',
    JARVIS_Get_Pin = 'JARVIS_Get_Pin',
    Get_Access_Token = 'Get_Access_Token',
    Delete_Client_Data = 'Delete_Client_Data',
    GetRatingsInfo = 'GetRatingsInfo',
    FeedbackAttachment = 'FeedbackAttachment',
    Image_Retrieval_Tile_Game = 'Image_Retrieval_Tile_Game',
    NES_Uninstall = 'NES_Uninstall',
    DR_Submit_Cart = 'DR_Submit_Cart',
    GetLayout = 'GetLayout',
    SendSurveyResponse = 'SendSurveyResponse',
    Feature_Tile_Image_Retrieval = 'Feature_Tile_Image_Retrieval',
    JARVIS_Get_Session_Token = 'JARVIS_Get_Session_Token',
    GetSpecificServerInformation = 'GetSpecificServerInformation',
    Layout_Manager_Data_Retrieval = 'Layout_Manager_Data_Retrieval',
    JARVIS_Get_User_Info = 'JARVIS_Get_User_Info',
    Streaming_GetJarvisDelegateToken = 'Streaming_GetJarvisDelegateToken',
    NES_Get_Product_Credits = 'NES_Get_Product_Credits',
    DR_Get_Cart = 'DR_Get_Cart',
    GetApps = 'GetApps',
    LinkAccount = 'LinkAccount',
    UnlinkAccount = 'UnlinkAccount',
    GetOAuthURL = 'GetOAuthURL',
    LibrarySync = 'LibrarySync',
    Other = 'Other',
    FetchJSFile = 'FetchJSFile',
    FetchLocaleJson = 'FetchLocaleJson',
    GetPanel = 'GetPanel',
    PNS_Registrations = 'PNS_Registrations',
    PNS_Unregister = 'PNS_Unregister',
    GetUserAccount = 'GetUserAccount',
    NES_GetClientStreamingQuality = 'NES_GetClientStreamingQuality',
    GetCampaigns = 'GetCampaigns',
    AcquireUser = 'AcquireUser',
    GetAcquisitionState = 'GetAcquisitionState',
    GetFilterGroupAndSortOrderDefinitions = 'GetFilterGroupAndSortOrderDefinitions',
    GetLoginWallData = 'GetLoginWallData',
    GetLoginWallStrings = 'GetLoginWallStrings',
    AddFavoriteApp = 'AddFavoriteApp',
    RemoveFavoriteApp = 'RemoveFavoriteApp',
    AddOwnedVariant = 'AddOwnedVariant',
    RemoveOwnedVariant = 'RemoveOwnedVariant',
    SelectOwnedVariant = 'SelectOwnedVariant',
    UdsEndOfSessionReport = 'UdsEndOfSessionReport',
    UdsSummonedReport = 'UdsSummonedReport',
    OverallGfnSupportedLanguages = 'OverallGfnSupportedLanguages',
    AppsPatchInfoWithLibraryFilter = 'AppsPatchInfoWithLibraryFilter',
    RestorePurchases = 'RestorePurchases',
    GetStoreSubscriptions = 'GetStoreSubscriptions',
    GetProductsMatrix = 'GetProductsMatrix',
    GetPaymentStrings = 'GetPaymentStrings',
    GetUserProducts = 'GetUserProducts',
    GrantFreeEntitlement = 'GrantFreeEntitlement',
    GenerateAppAccountToken = 'GenerateAppAccountToken',
    CreatePromotionalOfferSignature = 'CreatePromotionalOfferSignature'
}

export enum GameSyncState {
    Unknown = 'Unknown',
    Connected = 'Connected',
    Disconnected = 'Disconnected'
}

export enum OpenedFrom {
    HighlightsButton = 'HighlightsButton',
    OpenHotkey = 'OpenHotkey'
}

export enum AnselFreestyleFeatureDisableReason {
    FeatureNotAvailable = 'FeatureNotAvailable',
    FeatureDisabledReasonUnknown = 'FeatureDisabledReasonUnknown',
    NvCameraReadyNotificationNotReceived = 'NvCameraReadyNotificationNotReceived',
    NvCameraSessionConfigurationFailed = 'NvCameraSessionConfigurationFailed'
}

export enum ActivityState {
    Enabled = 'Enabled',
    Disabled = 'Disabled'
}

export enum NetworkQuality {
    Excellent = 'Excellent',
    Poor = 'Poor',
    Bad = 'Bad',
    Unknown = 'Unknown'
}

export enum HitEventType {
    SelfUpdateInstallAuto = 'SelfUpdateInstallAuto',
    SelfUpdateInstallManual = 'SelfUpdateInstallManual',
    CustomOfflinePage = 'CustomOfflinePage',
    LaunchUI = 'LaunchUI',
    FirstApplicationInstall = 'FirstApplicationInstall',
    LaunchPwaUI = 'LaunchPwaUI',
    ScheduledMaintenanceTimer = 'ScheduledMaintenanceTimer',
    SessionLengthTimer = 'SessionLengthTimer',
    UDSToastShown = 'UDSToastShown'
}

export enum OobeProgressEventName {
    OobeAgreeAndContinue = 'OobeAgreeAndContinue',
    OobeTermsOfUseHyperlink = 'OobeTermsOfUseHyperlink'
}

export enum TelemetryBoolean {
    No = 'No',
    Yes = 'Yes',
    None = 'None'
}

export enum DeeplinkError {
    GameNotFound = 'GameNotFound',
    BadRequest = 'BadRequest',
    Unknown = 'Unknown',
    ServerError = 'ServerError',
    ClipboardError = 'ClipboardError',
    Unauthorized = 'Unauthorized',
    PartnerAuthFailed = 'PartnerAuthFailed',
    ZoneNotFound = 'ZoneNotFound',
    RedirectURLNotAllowed = 'RedirectURLNotAllowed',
    None = 'None'
}

export enum GameSyncUserAction {
    AccountLinked = 'AccountLinked',
    Disconnect = 'Disconnect',
    ResyncAfterResolve = 'ResyncAfterResolve',
    ResyncAfterProfileCreate = 'ResyncAfterProfileCreate',
    Sync = 'Sync',
    Resync = 'Resync',
    ReconnectForOnboarding = 'ReconnectForOnboarding',
    Reconnect = 'Reconnect',
    ReconnectAfterSyncDenied = 'ReconnectAfterSyncDenied',
    ResyncAfterSyncFailed = 'ResyncAfterSyncFailed',
    Autoresync = 'Autoresync',
    SyncPostPlatformSelection = 'SyncPostPlatformSelection'
}

export enum NetworkTestPolicy {
    FingerprintChanged = 'FingerprintChanged',
    ClientUpdated = 'ClientUpdated',
    StreamerNetworkError = 'StreamerNetworkError',
    NetworkTestCancelled = 'NetworkTestCancelled',
    OverrideFlagSet = 'OverrideFlagSet',
    MaxDisplayRequired = 'MaxDisplayRequired',
    PolicyCheckFailed = 'PolicyCheckFailed',
    Manual = 'Manual',
    RedResult = 'RedResult',
    NetworkTestFailed = 'NetworkTestFailed',
    MaxSubscriptionProfileUpgraded = 'MaxSubscriptionProfileUpgraded'
}

export enum ClientHost {
    Standalone = 'Standalone',
    GFN = 'GFN'
}

export enum MontageUserAction {
    Cancel = 'Cancel',
    Create = 'Create',
    Complete = 'Complete',
    Enter = 'Enter'
}

export enum ActivityExperienceType {
    Variant = 'Variant',
    Control = 'Control',
    Default = 'Default',
    Alternate = 'Alternate'
}

export enum DiskMediumType {
    SolidState = 'SolidState',
    Unknown = 'Unknown',
    Rotational = 'Rotational'
}

export enum IPVersion {
    Unknown = 'Unknown',
    Ipv6 = 'Ipv6',
    Ipv4 = 'Ipv4'
}

export enum GfnViewNames {
    Streamer = 'Streamer',
    Gallery = 'Gallery',
    Layout_L0 = 'Layout_L0',
    Settings = 'Settings',
    Layout_L1 = 'Layout_L1'
}

export enum GalleryContentAction {
    Add = 'Add',
    Delete = 'Delete',
    TrimNew = 'TrimNew',
    Play = 'Play',
    OpenLocation = 'OpenLocation',
    TrimReplace = 'TrimReplace',
    Preview = 'Preview'
}

export enum NetworkTypeEnum {
    Other = 'Other',
    Ethernet = 'Ethernet',
    Unknown = 'Unknown',
    Wifi_2_4 = 'Wifi_2_4',
    Wifi_5_0 = 'Wifi_5_0',
    Wifi_6_0 = 'Wifi_6_0',
    Wifi_Unknown = 'Wifi_Unknown',
    Mobile = 'Mobile',
    Mobile_2G = 'Mobile_2G',
    Mobile_3G = 'Mobile_3G',
    Mobile_4G = 'Mobile_4G',
    Mobile_5G = 'Mobile_5G',
    Wimax = 'Wimax',
    Bluetooth = 'Bluetooth'
}

export enum NetworkTestMode {
    Manual = 'Manual',
    Automatic = 'Automatic'
}

export enum LayoutRefreshTriggers {
    TabSwitch = 'TabSwitch',
    SessionEndPushNotification = 'SessionEndPushNotification',
    LocaleChange = 'LocaleChange',
    StreamerInstanceClosed = 'StreamerInstanceClosed',
    ClickRetry = 'ClickRetry',
    TwentyFourHourRefresh = 'TwentyFourHourRefresh',
    AppMetadataRefresh = 'AppMetadataRefresh',
    FocusGain = 'FocusGain',
    StreamerTerminated = 'StreamerTerminated',
    LoginStatusChange = 'LoginStatusChange',
    RemoveGame = 'RemoveGame',
    VpcIdRefresh = 'VpcIdRefresh',
    RemoveGameFailed = 'RemoveGameFailed',
    IntegrationChanged = 'IntegrationChanged',
    EcomStatusChanged = 'EcomStatusChanged',
    OnlineStatusChange = 'OnlineStatusChange',
    AppsListRefresh = 'AppsListRefresh',
    RefreshOnDataExpiry = 'RefreshOnDataExpiry',
    InitialFetch = 'InitialFetch',
    UserSKUChanged = 'UserSKUChanged',
    RefreshOnCampaignChange = 'RefreshOnCampaignChange'
}

export enum PluginName {
    SystemInfo = 'SystemInfo',
    Payment = 'Payment'
}

export enum EventStatus {
    StreamerConnecting = 'StreamerConnecting',
    CancelledLoginCompleted = 'CancelledLoginCompleted',
    RagnarokLaunchError = 'RagnarokLaunchError',
    Success = 'Success',
    StreamerQueueUpsell = 'StreamerQueueUpsell',
    HTTPError = 'HTTPError',
    StreamerPostSessionFreeGaaSUpsell = 'StreamerPostSessionFreeGaaSUpsell',
    StreamerQueueApology = 'StreamerQueueApology',
    StreamerPostSessionUpsell = 'StreamerPostSessionUpsell',
    NesAuthFailed = 'NesAuthFailed',
    StreamerPostSessionAnonGaaSUpsell = 'StreamerPostSessionAnonGaaSUpsell',
    GeronimoLaunchError = 'GeronimoLaunchError',
    Failure = 'Failure',
    AppExit = 'AppExit',
    StreamerUsedFreeUpsell = 'StreamerUsedFreeUpsell',
    JarvisPinAuthFailed = 'JarvisPinAuthFailed',
    StreamerLoading = 'StreamerLoading',
    StreamerNoFreeUpsell = 'StreamerNoFreeUpsell',
    NesNotEntitled = 'NesNotEntitled',
    EmailNotVerified = 'EmailNotVerified',
    ServerError = 'ServerError',
    ECommercePaywallLaunchError = 'ECommercePaywallLaunchError',
    NetworkInfoError = 'NetworkInfoError',
    LoginFailed = 'LoginFailed',
    GeronimoNetworkTestError = 'GeronimoNetworkTestError',
    NetworkTestSdkError = 'NetworkTestSdkError',
    EmptyLibrary = 'EmptyLibrary',
    GetLayoutError = 'GetLayoutError',
    ClientError = 'ClientError',
    ClientOffline = 'ClientOffline',
    Other = 'Other',
    ServiceWorkerActivationOngoing = 'ServiceWorkerActivationOngoing',
    ServiceWorkerActivated = 'ServiceWorkerActivated',
    UALoginComplete = 'UALoginComplete',
    UALoginFailed = 'UALoginFailed',
    UALoginPending = 'UALoginPending',
    UALoginPendingTimedOut = 'UALoginPendingTimedOut',
    UALoginPendingSuccess = 'UALoginPendingSuccess',
    UALoginPendingFailure = 'UALoginPendingFailure',
    ServiceWorkerRegistrationFailed = 'ServiceWorkerRegistrationFailed',
    ServiceWorkerRegistrationSuccess = 'ServiceWorkerRegistrationSuccess',
    ServiceWorkerNotSupported = 'ServiceWorkerNotSupported',
    ServiceWorkerInstalled = 'ServiceWorkerInstalled',
    ServiceWorkerActivationError = 'ServiceWorkerActivationError',
    Registered = 'Registered',
    NotRegistered = 'NotRegistered',
    Played = 'Played',
    TimedOut = 'TimedOut',
    Unknown = 'Unknown'
}

export enum GalleryUserAction {
    DeleteUndo = 'DeleteUndo',
    Enter = 'Enter',
    FiltersCleared = 'FiltersCleared',
    TrimCancel = 'TrimCancel',
    Montage = 'Montage',
    Edit = 'Edit'
}

export enum ScreenPos {
    UpperRight = 'UpperRight',
    LowerRight = 'LowerRight',
    UpperLeft = 'UpperLeft',
    LowerLeft = 'LowerLeft',
    None = 'None'
}

export enum AnselMode {
    Freestyle = 'Freestyle',
    AnselLite = 'AnselLite',
    Ansel = 'Ansel'
}

export enum AutoUpdateStatus {
    UpdateSuccess = 'UpdateSuccess',
    UpdateFailure = 'UpdateFailure',
    QueryFailure = 'QueryFailure',
    DownloadStarted = 'DownloadStarted',
    Query = 'Query',
    IPCReceived = 'IPCReceived',
    UpdateInitiated = 'UpdateInitiated',
    IPCSent = 'IPCSent',
    DownloadFailure = 'DownloadFailure',
    Error = 'Error',
    Optimization = 'Optimization',
    Downloaded = 'Downloaded',
    Cancelled = 'Cancelled'
}

export enum NavLevel {
    Root = 'Root',
    Content = 'Content',
    Folder = 'Folder'
}

export enum DeeplinkShareType {
    UGC = 'UGC',
    Game = 'Game'
}

export enum ScreenName {
    ScreenOobeWelcome = 'ScreenOobeWelcome',
    ScreenToastMessage = 'ScreenToastMessage',
    ScreenMainToolbar = 'ScreenMainToolbar',
    ScreenMarquee = 'ScreenMarquee',
    ScreenAllGames = 'ScreenAllGames',
    ScreenAccountMenu = 'ScreenAccountMenu',
    ScreenSettings = 'ScreenSettings',
    ScreenAutoLogin = 'ScreenAutoLogin',
    ScreenMontage = 'ScreenMontage',
    ScreenEmailVerification = 'ScreenEmailVerification',
    ScreenPreview = 'ScreenPreview',
    ScreenGallery = 'ScreenGallery',
    ScreenStreamer = 'ScreenStreamer',
    ScreenMyLibrary = 'ScreenMyLibrary',
    ScreenJoinGfnDialog = 'ScreenJoinGfnDialog',
    ScreenGridView = 'ScreenGridView',
    ScreenEvidencePanel = 'ScreenEvidencePanel',
    ScreenMallHome = 'ScreenMallHome',
    ScreenPlatformSelectionDialog = 'ScreenPlatformSelectionDialog',
    ScreenSwitchProvider = 'ScreenSwitchProvider',
    ScreenUpgradeBanner = 'ScreenUpgradeBanner',
    ScreenDesktopShortcut = 'ScreenDesktopShortcut',
    ScreenPlaytimeNotAddedDialog = 'ScreenPlaytimeNotAddedDialog',
    ScreenAddPlaytimeBanner = 'ScreenAddPlaytimeBanner',
    ScreenLimitedStateGameLaunchDialog = 'ScreenLimitedStateGameLaunchDialog',
    ScreenLowStateGameLaunchDialog = 'ScreenLowStateGameLaunchDialog',
    ScreenLowPlaytimeDayPassBanner = 'ScreenLowPlaytimeDayPassBanner',
    ScreenDayPassExpiryBanner = 'ScreenDayPassExpiryBanner',
    ScreenLowPlaytimeDayPassDialog = 'ScreenLowPlaytimeDayPassDialog',
    ScreenHelpMenu = 'ScreenHelpMenu',
    ScreenIap = 'ScreenIap'
}

export enum MontageState {
    Unknown = 'Unknown',
    Cancel = 'Cancel',
    Create = 'Create',
    Failure = 'Failure'
}

export enum GameLaunchSourceType {
    Unknown = 'Unknown',
    GeForceNOW = 'GeForceNOW',
    External = 'External',
    Deeplink = 'Deeplink'
}

export enum ActivityType {
    AB = 'AB',
    Unknown = 'Unknown',
    XT = 'XT',
    FR = 'FR'
}

export enum GFNSDKAuthType {
    Jarvis = 'Jarvis',
    JWT = 'JWT',
    SteamNonce = 'SteamNonce',
    Other = 'Other'
}

export enum FilterCategory {
    InstantReplay = 'InstantReplay',
    Highlight = 'Highlight',
    Video = 'Video',
    Screenshot = 'Screenshot',
    None = 'None'
}

export enum SearchFilterTriggerOperation {
    Search = 'Search',
    FilterTile = 'FilterTile',
    SeeAll = 'SeeAll',
    Deeplink = 'Deeplink',
    Marquee = 'Marquee',
    FilterPanelAddFilter = 'FilterPanelAddFilter',
    FilterPanelRemoveFilter = 'FilterPanelRemoveFilter',
    FilterChipRemoveFilter = 'FilterChipRemoveFilter',
    LibraryItemRemoved = 'LibraryItemRemoved',
    SortOrderChanged = 'SortOrderChanged',
    ClearAll = 'ClearAll',
    AppsRefresh = 'AppsRefresh',
    LibraryRefresh = 'LibraryRefresh',
    CampaignRefresh = 'CampaignRefresh',
    ManualRetry = 'ManualRetry',
    NextPage = 'NextPage',
    None = 'None'
}

export enum PushNotificationErrorCategory {
    TOKEN_REGISTRATION = 'TOKEN_REGISTRATION',
    DISPATCH_NOTIFICATION = 'DISPATCH_NOTIFICATION',
    DEVICE_REGISTRATION = 'DEVICE_REGISTRATION',
    CLIENT_SERVER_COMMUNICATION = 'CLIENT_SERVER_COMMUNICATION',
    SUBSCRIPTION = 'SUBSCRIPTION',
    PAYLOAD_DECRYPTION = 'PAYLOAD_DECRYPTION',
    GENERAL = 'GENERAL'
}

export enum UIActionName {
    Join = 'Join',
    Close = 'Close',
    Login = 'Login'
}

export enum PushNotificationRegistrationProvider {
    NNS = 'NNS',
    PNS = 'PNS'
}

export enum GalleryMediaSubType {
    InstantReplay = 'InstantReplay',
    Highlight = 'Highlight',
    Manual = 'Manual',
    Montage = 'Montage',
    Screenshot = 'Screenshot',
    Normal = 'Normal'
}

export enum StreamingMediaType {
    Video = 'Video',
    Audio = 'Audio'
}

export enum MediaPlayResult {
    Success = 'Success',
    Failure = 'Failure'
}

export enum StatsFormat {
    Standard = 'Standard',
    Compact = 'Compact'
}

export enum GFNEventType {
    EventNone = 'EventNone',
    EditBox = 'EditBox'
}

export enum OsdHudIndicators {
    Recording = 'Recording',
    IR = 'IR',
    Highlights = 'Highlights',
    Mic = 'Mic',
    Statistics = 'Statistics',
    Network = 'Network'
}

export enum IgoNotificationControls {
    Empty = 'Empty',
    OpenOverlay = 'OpenOverlay',
    ConnectionStatus = 'ConnectionStatus',
    SaveIRToGallery = 'SaveIRToGallery',
    SaveMRToGallery = 'SaveMRToGallery',
    SaveSSToGallery = 'SaveSSToGallery',
    SaveHLToGallery = 'SaveHLToGallery',
    IROnOff = 'IROnOff',
    MROn = 'MROn',
    BCOnOff = 'BCOnOff',
    BCPauseResume = 'BCPauseResume'
}

export enum PlaytesterActionType {
    SessionStart = 'SessionStart',
    SessionStop = 'SessionStop',
    SessionConsentDenied = 'SessionConsentDenied'
}

export enum PlaytesterActionStatus {
    Success = 'Success',
    Failure = 'Failure',
    Unknown = 'Unknown'
}

export enum RemainingPlayTimeState {
    Full = 'Full',
    Low = 'Low',
    Limited = 'Limited'
}

export enum CurrentUiMode {
    Desktop = 'Desktop',
    Mobile = 'Mobile',
    Game = 'Game',
    Unknown = 'Unknown'
}

export enum SelfUpdateCategory {
    UpdateCheckAttemptsExhausted = 'UpdateCheckAttemptsExhausted',
    DownloadAttemptExhausted = 'DownloadAttemptExhausted',
    InstallationAttemptExhausted = 'InstallationAttemptExhausted',
    Banner = 'Banner'
}

export enum SelfUpdateAction {
    PopupShown = 'PopupShown',
    RelaunchNow = 'RelaunchNow',
    Redirect = 'Redirect',
    Dismissed = 'Dismissed'
}

export enum ResourceType {
    Html = 'Html',
    Json = 'Json',
    Image = 'Image',
    Video = 'Video',
    Marquee = 'Marquee',
    Icon = 'Icon',
    Unknown = 'Unknown'
}

export enum QuitGameUseCase {
    FromMall = 'FromMall',
    FromStreamer = 'FromStreamer'
}

export enum OwnershipFlowEnd {
    Done = 'Done',
    Aborted = 'Aborted'
}

export enum GameOwnershipType {
    Store = 'Store',
    Subscription = 'Subscription',
    None = 'None'
}

export enum GameOwnershipMethod {
    Manual = 'Manual',
    AutoSync = 'AutoSync',
    StoreConnection = 'StoreConnection',
    MultiStoreConnection = 'MultiStoreConnection',
    Demo = 'Demo',
    None = 'None'
}

export enum OwnershipFlowEntryPoint {
    MarkAsOwned = 'MarkAsOwned',
    Crosslink = 'Crosslink',
    PlatformChange = 'PlatformChange',
    GetGame = 'GetGame',
    Unknown = 'Unknown'
}

export enum OwnershipFlowGameType {
    Demo = 'Demo',
    Free = 'Free',
    Paid = 'Paid',
    Unknown = 'Unknown'
}

export enum OwnershipFlowState {
    AutoResync = 'AutoResync',
    PlatformSelection = 'PlatformSelection',
    AutoMarkFreeToPlayGame = 'AutoMarkFreeToPlayGame',
    FreeGameConfirmation = 'FreeGameConfirmation',
    Success = 'Success',
    ManualMark = 'ManualMark',
    Error = 'Error',
    Complete = 'Complete',
    Connection_Prompt = 'Connection_Prompt',
    Connection_InProgress = 'Connection_InProgress',
    Connection_Sync = 'Connection_Sync',
    Connection_SubscriptionNotFound = 'Connection_SubscriptionNotFound',
    Connection_CrosslinkRequired = 'Connection_CrosslinkRequired',
    Connection_GameNotFound = 'Connection_GameNotFound',
    Connection_ExternalLink = 'Connection_ExternalLink',
    Connection_ResyncPrompt = 'Connection_ResyncPrompt',
    Connection_Failed = 'Connection_Failed',
    Connection_Expired = 'Connection_Expired',
    Sync_Failed = 'Sync_Failed',
    BuyPlatformSelection = 'BuyPlatformSelection',
    Unknown = 'Unknown'
}

/////// Event interface Declarations ////////
export interface GpuData {
    gpuLongName: string;
    gpuVDSR: string;
}

export interface FeatureState {
    name: string;
    state: string;
}

export interface DisplayData {
    physicalRes: string;
    logicalRes: string;
    refreshRate: Uint16;
    displayNumber: Uint16;
}

export interface RuntimeModuleInfo {
    moduleName: string;
    moduleBranch: string;
    moduleVersion: string;
    moduleCommit: string;
}

export interface CaptureEvent {
    modsActive: TelemetryBoolean;
    cmsId: String;
    clientHost: ClientHost;
    action: CaptureAction;
    sessionId: String;
    shortName: String;
    timeMs: Counter;
    captureMethod: String;
    recordWidth: Counter;
    recordHeight: Counter;
    recordFramerate: Uint16;
    recordCodec: String;
    colorSpaceRange: String;
    errorType: String;
    errorDetails: String;
}

export interface GalleryContentEvent {
    game: String;
    cmsId: Int32;
    filesizeKB: Int32;
    ageMs: Counter;
    mediaType: GalleryMediaType;
    eventType: GalleryContentAction;
    durationMs: Counter;
    mediaSubtype: GalleryMediaSubType;
    errorType: String;
    errorDetails: String;
}

export interface ClientAudioError {
    errorCodeString: String;
    errorType: AudioErrorType;
    errorMessage: String;
    errorDetails: String;
}

export interface AnselFreestyleError {
    mode: AnselMode;
    errorString: String;
    cmsId: String;
    errorType: AnselFreestyleFailureType;
    serverOSVersion: String;
    usedMenu: TelemetryBoolean;
    shortName: String;
    serverGPUType: String;
    errorSubType: String;
}

export interface HighlightsGameSetting {
    modsActive: TelemetryBoolean;
    cmsId: String;
    clientHost: ClientHost;
    permissionSource: HighlightsPermissionSource;
    isOn: TelemetryBoolean;
    sessionId: String;
    shortName: String;
}

export interface TextSearch {
    selectedPreview: String;
    aggregatedPreviews: String;
    rank4Result: String;
    searchType: SearchType;
    rank3Result: String;
    rank1Result: String;
    searchQuery: String;
    rank2Result: String;
    selectedResult: String;
    selectedRank: Uint16;
    rank0Result: String;
}

export interface ProcessStarted {
    processType: ProcessType;
}

export interface MicrophoneSettingChange {
    requestedState: String;
    resultState: String;
    streamSessionId: IdString;
    startState: String;
    subSessionId: String;
}

export interface MicrophoneInitialized {
    uiMicState: String;
    internalMicState: String;
    streamSessionId: IdString;
    streamSubSessionId: IdString;
}

export interface CheckGFN {
    originalCmsId: String;
    timeTaken: Counter;
    originalAuthMethod: GFNSDKAuthType;
    gfnSDKVersion: String;
    gfnDLLVersion: String;
    originalTimestamp: Counter;
    status: String;
    originalSource: String;
    originalShortname: String;
}

export interface UIAction {
    actionTaken: UIActionName;
    uiVariant: UIVariantName;
}

export interface QueueEtaUpgradeClicked {
    durationMs: Counter;
}

export interface QueueEtaAddPlaytimeClicked {
    durationMs: Counter;
}

export interface AudioNotificationEvent {
    scenario: String;
    status: EventStatus;
    errorDetails: String;
}

export interface PopUpDialogClosed {
    totalMs: Counter;
    name: PopUpDialogType;
    inWindowClicks: Counter;
    scrolled: BooleanType;
    exitTriggerPoint: DialogExitType;
    checkBoxChecked: BooleanType;
}

export interface NetworkTest_Exception_Event {
    networkSessionId: String;
    filename: String;
    lineno: Counter;
    stacktrace: String;
    colno: Counter;
    handled: BooleanType;
    zoneAddress: String;
    category: String;
    message: String;
}

export interface Game_Launch_Event {
    gameLaunchSource: GameLaunchSourceType;
    gameType: String;
    gameShortName: String;
    accountLinks: String[];
    isResume: BooleanType;
    streamSessionId: IdString;
    clientPerceivedSessionTimeMs: Counter;
}

export interface Game_Quit_Event {
    useCase: QuitGameUseCase;
    streamSessionId: IdString;
    clientPerceivedSessionTimeMs: Counter;
}

export interface LaunchProcess {
    sender: ProcessType;
    isUserAdmin: BooleanType;
    errorMessage: String;
    errorCode: Int32;
    processType: ProcessType;
    status: BooleanType;
}

export interface ClientImeOpenEvent {
    streamDuration: Counter;
    source: String;
}

export interface OpenedIGO {
    cmsId: String;
    clientHost: ClientHost;
    totalMs: Counter;
    sessionId: String;
    openedFrom: OpenedFrom;
    shortName: String;
}

export interface GalleryPlayedVideo {
    cmsId: String;
    clientHost: ClientHost;
    highlightId: String;
    sessionId: String;
    shortName: String;
}

export interface AnselFreestyleFeatureDisabled {
    mode: AnselMode;
    cmsId: String;
    serverInfo: String;
    errorType: AnselFreestyleFeatureDisableReason;
    errorInfo: String;
    shortName: String;
}

export interface SettingSnapshot {
    highlightsHUDLocation: ScreenPos;
    mrHotkey: String;
    instantReplayHUDLocation: ScreenPos;
    clientHost: ClientHost;
    highlightSavedIndicatorOn: TelemetryBoolean;
    irToggleIndicatorOn: TelemetryBoolean;
    gallerySpaceUsedPercent: Uint16;
    saveIRHotkey: String;
    recordingHUDLocation: ScreenPos;
    irSavedIndicatorOn: TelemetryBoolean;
    mrStartedIndicatorOn: TelemetryBoolean;
    micHUDLocation: ScreenPos;
    connectionStatusHUDLocation: ScreenPos;
    mrSavedIndicatorOn: TelemetryBoolean;
    gallerySizeMB: Int32;
    irToggleHotkey: String;
    numGalleryVideos: Int32;
    typeOfStorageDrive: StorageType;
    screenshotHotkey: String;
    numGalleryImages: Int32;
    galleryTotalSizeMB: Counter;
    openIGOHotkey: String;
    screenshotSavedIndicatorOn: TelemetryBoolean;
    areGlobalHighlightsOn: TelemetryBoolean;
    instantReplayBufferLength: Int32;
    statsHotkey: String;
    statsLocation: ScreenPos;
    statsFormat: StatsFormat;
}

export interface Application_Install {
    clientType: ClientType;
    type: HitEventType;
    osName: String;
    previousAppVersion: VersionString;
}

export interface QueueAbandoned {
    durationMs: Counter;
}

export interface OwnershipSyncEvent {
    userAction: GameSyncUserAction;
    totalNumberOfGfnSupportedGames: Int32;
    syncDate: String;
    state: GameSyncState;
    serviceProviderName: String;
    status: GameSyncStatus;
    subscriptionFound: String;
}

export interface PopUpDialogShown {
    name: PopUpDialogType;
}

export interface PushNotificationReceived {
    requestId: String;
    sentTs: Counter;
    type: PushNotificationMessageType;
    projectId: String;
    ttl: Counter;
}

export interface UITransition {
    transitionTimeMs: Counter;
    clientHost: ClientHost;
    lingerTimeMs: Counter;
    oldState: UIStateName;
    sessionId: String;
    newState: UIStateName;
}

export interface OOBE_Accept {
    currentScreen: ScreenName;
    technicalConsent: OobeConsentType;
    action: OobeProgressEventName;
}

export interface RoutingStatus {
    networkSessionId: String;
    totalMs: Counter;
    errorCode: NetworkErrorCode;
    overrideZone: InfoString;
    overrideActive: BooleanType;
    clientType: ClientType;
    clientRecommendedZoneLatency: Uint16;
    clientRecommendedZone: URLString;
    serverRecommendedZone: URLString;
    ipAddresses: String;
    results: String;
    status: EventStatus;
    errorDetails: ErrorMessage;
    policy: LBRPolicy;
}

export interface CrashInfo {
    exceptionType: ErrorMessage;
    appVersion: String;
    fileName: String;
    processName: String;
    crashedThreadName: String;
    crashedThreadSummary: String;
    streamSessionId: IdString;
    exceptionCode: ErrorMessage;
    appSpecificInfo: ErrorMessage;
    timestamp: String;
    crashedThreadBacktrace: ErrorMessage;
}

export interface HTTPFailure {
    destinationIp: String;
    serviceSubUseCase: ServiceSubUseCaseName;
    networkErrorCode: NetworkErrorCode;
    sourceComponent: ClientType;
    serviceUseCase: ServiceUseCaseName;
    originalService: OriginalServiceName;
    xRequestId: String;
    url: URLString;
    retryCount: Counter;
    wasSWCacheBypassed: BooleanType;
    networkErrorMessage: String;
}

export interface AnselFreestyleSession {
    mode: AnselMode;
    panningWithKB: TelemetryBoolean;
    usedMouse: TelemetryBoolean;
    cmsId: String;
    usedKeyboard: TelemetryBoolean;
    totalMs: Counter;
    panningWithMouse: TelemetryBoolean;
    shortName: String;
    panningUsed: TelemetryBoolean;
}

export interface PushNotificationTokenRegistered {
    registrationProvider: PushNotificationRegistrationProvider;
    projectId: String;
}

export interface AutoUpdate {
    errorCategory: AutoUpdateErrorCategory;
    previousVersion: String;
    retryCount: Uint16;
    updateUrl: URLString;
    channel: String;
    errorMessage: ErrorMessage;
    upTimeMs: Counter;
    downloadTimeMs: Counter;
    targetVersion: String;
    status: AutoUpdateStatus;
}

export interface LayoutTelemetry {
    liveDataSuccessful: BooleanType;
    failurePoint: LayoutPipelineStage;
    isUserLoggedIn: BooleanType;
    layoutKey: String;
    cachedDataSuccessful: BooleanType;
    vpcId: String;
    errorCode: NetworkErrorCode;
    trigger: LayoutRefreshTriggers;
    error: String;
    isUserOnline: BooleanType;
}

export interface BrowserClientCanary {
    currentOriginCookieValue: String;
    gxtResponseValue: String;
    newOriginCookieValue: String;
}

export interface HTTPSuccess {
    destinationIp: String;
    serviceSubUseCase: ServiceSubUseCaseName;
    sourceComponent: ClientType;
    serviceUseCase: ServiceUseCaseName;
    originalService: OriginalServiceName;
    httpStatus: HTTPStatusCode;
    xRequestId: String;
    responseData: String;
    durationMs: Counter;
    url: URLString;
    retryCount: Counter;
    wasSWCacheBypassed: BooleanType;
}

export interface HTTPCallResult {
    destinationIp: String;
    serviceSubUseCase: ServiceSubUseCaseName;
    sourceComponent: ClientType;
    serviceUseCase: ServiceUseCaseName;
    originalService: OriginalServiceName;
    httpStatus: HTTPStatusCode;
    xRequestId: String;
    responseData: String;
    durationMs: Counter;
    url: URLString;
    retryCount: Counter;
    networkErrorCode: NetworkErrorCode;
    wasSWCacheBypassed: BooleanType;
}

export interface SDKCallResult {
    cmsId: String;
    clientHost: ClientHost;
    apiAction: SDKCallAction;
    count: Int32;
    sdkVersion: String;
    sessionId: String;
    shortName: String;
    highlightsSessionId: String;
    apiStatus: String;
    internalCode: Int32;
}

export interface IgoShortcuts {
    actionName: String;
    shortcutKey: String;
    isGamepadBasedShortcut: TelemetryBoolean;
}

export interface Drag {
    itemType: DragItemType;
    hierarchy: InfoString;
    itemLabel: InfoString;
}

export interface HighlightsIndividualGameToggle {
    cmsId: String;
    clientHost: ClientHost;
    isOn: TelemetryBoolean;
    highlightId: String;
    shortName: String;
}

export interface NetworkTest {
    latencyWithStream: Counter;
    latency: Counter;
    totalMs: Counter;
    resultCode: Uint16;
    errorCode: Uint16;
    overrideActive: BooleanType;
    clientType: ClientType;
    networkTestMode: NetworkTestMode;
    zone: InfoString;
    errorReason: NetworkTestErrorReason;
    displayProfile: DisplayProfiles;
    userCapableProfileWidth: Uint16;
    userCapableProfileHeight: Uint16;
    userCapableProfileFrameRate: Uint16;
    maxUserCapableProfileWidth: Uint16;
    maxUserCapableProfileHeight: Uint16;
    maxUserCapableProfileFrameRate: Uint16;
    maxSubscriptionProfileWidth: Uint16;
    maxSubscriptionProfileHeight: Uint16;
    maxSubscriptionProfileFrameRate: Uint16;
    maxTestBandwidthMbps: Float;
    networkType: NetworkTypeEnum;
    networkTestVersion: Uint16;
    VPNConnection: BooleanType;
    policy: NetworkTestPolicy;
    networkSessionId: String;
    bandwidth: Float;
    uplinkBandwidth: Float;
    overrideZone: InfoString;
    dataLoss: Float;
    percentile99thFrameJitter: Float;
    networkQuality: NetworkQuality;
    measuredPathMtu: Uint16;
    status: EventStatus;
    errorDetails: String;
    maxPacketSize: Uint16;
    zoneName: String;
}

export interface GFNSession {
    cmsId: String;
    wasHighlightsAvailable: TelemetryBoolean;
    sessionId: String;
    shortName: String;
    sessionDurationMs: Counter;
}

export interface DeeplinkSource {
    gameId: String;
    cmsId: Int32;
    action: DeeplinkAction;
    source: String;
    store: String;
    zone: String;
    errors: DeeplinkError[];
    utmSource: String;
    utmCampaign: String;
    utmMedium: String;
    utmTerm: String;
    utmContent: String;
    partnerId: String;
    additionalErrorInfo: String;
}

export interface HIDInfo {
    clientType: ClientType;
    productID: IdString;
    inputDevice: HID;
    vendorID: IdString;
    transport: String;
    reportIntervalMicroSeconds: Counter;
    versionNumber: VersionString;
    manufacturer: String;
}

export interface SystemInfo {
    physicalMemoryCapacity: Counter;
    disk2FreeSpace: Counter;
    diskCount: Counter;
    disk1TotalSize: Counter;
    launchSource: String;
    platform: PlatformType;
    dxVersion: String;
    clientVariant: ClientVariantType;
    systemName: String;
    osVersion: String;
    gpu0LongName: String;
    disk2TotalSize: Counter;
    disk0MediumType: DiskMediumType;
    displayCount: Counter;
    disk2MediumType: DiskMediumType;
    networkType: NetworkTypeEnum;
    gpuCount: Counter;
    disk0TotalSize: Counter;
    disk1FreeSpace: Counter;
    routerMacAddress: String;
    gpu1LongName: String;
    userAgent: String;
    vendorName: String;
    osName: String;
    cpuName: String;
    userDefaultUILanguage: String;
    disk1MediumType: DiskMediumType;
    processorArchitecture: String;
    disk0FreeSpace: Counter;
    browserName: String;
    browserVersion: String;
    confidenceInBrowser: Uint16;
    isBrowserForged: BooleanType;
    displayDetails: DisplayData[];
    systemInfoGuid: String;
    clientUrl: URLString;
    currentUiMode: CurrentUiMode;
    preferredGameLanguage: String;
    isAutoPreferredGameLanguage: BooleanType;
    connectedByVM: BooleanType;
}

export interface GameSearchFilterEvent {
    searchQuery: String;
    appliedFilterIds: String[];
    appliedSortOrder: String;
    triggeringOperation: SearchFilterTriggerOperation;
    totalResults: Int32;
}

export interface GalleryOpenedFileLocation {
    cmsId: String;
    clientHost: ClientHost;
    sessionId: String;
    shortName: String;
}

export interface Click {
    itemType: ClickItemType;
    hierarchy: InfoString;
    itemLabel: InfoString;
    inputSource: ClickInputSource;
    gameCampaignId: InfoString;
    additionalData: InfoString;
}

export interface AnselFreestyleFilters {
    mode: AnselMode;
    cmsId: String;
    filterName: String;
    shortName: String;
}

export interface GalleryFilterUsed {
    clientHost: ClientHost;
    filterCategory: FilterCategory;
    sessionId: String;
}

export interface UserSession {
    userAction: UserAction;
    errorUri: String;
    clientType: ClientType;
    currentScreen: ScreenName;
    totalMs: Counter;
    serverErrorCode: String;
    status: EventStatus;
    errorDetails: ErrorMessage;
}

export interface NavigationPerformanceMetrics {
    requestResponseDuration: Counter;
    domainLookupDuration: Counter;
    pageRenderDuration: Counter;
    redirectDuration: Counter;
    responseDuration: Counter;
    connectDuration: Counter;
    timeToFirstByte: Counter;
    pageLoadDuration: Counter;
}

export interface GalleryDeleteCountEvent {
    count: Int32;
}

export interface MontageEvent {
    mediaTypeCountHighlight: Int32;
    itemsRearranged: Int32;
    durationToCreateMs: Counter;
    celebration: String;
    titleSequenceChanged: BooleanType;
    numberOfDifferentGames: Int32;
    games: String;
    lengthOfMontageMs: Counter;
    subtitleSequenceChanged: BooleanType;
    state: MontageState;
    mediaTypeCountNormal: Int32;
    mediaTypeCountMontage: Int32;
    numberOfClips: Int32;
    itemsDeleted: Int32;
    averageClipLengthMs: Counter;
    mediaTypeCountManual: Int32;
    errorDetails: String;
}

export interface CreateHTTPServerError {
    portsUsed: String;
    errorMessage: String;
}

export interface AnselScreenshotEvent {
    gpuName: String;
    cmsId: Counter;
    installedDDVersion: VersionString;
    errorType: OscAnselScreenshotFailureType;
    stackedFilters: String;
    totalMs: Counter;
    screenshotType: AnselScreenshotType;
    roll: Int32;
    panningUsed: TelemetryBoolean;
    fov: Int32;
    screenshotResolution: String;
    mode: AnselMode;
    errorString: String;
    gridUsed: TelemetryBoolean;
    state: AnselScreenshotState;
    shortName: String;
}

export interface Hit_Event {
    clientType: ClientType;
    type: HitEventType;
}

export interface CloudSearch {
    directResults: String;
    searchType: SearchType;
    searchQuery: String;
}

export interface AuthenticationProvider {
    supportedProviders: InfoString;
    isAffiliateRegion: BooleanType;
    providerName: InfoString;
}

export interface ExperienceControlInfo {
    experienceId: String;
    variantType: ActivityExperienceType;
    experienceTestType: ActivityType;
    experienceName: String;
    state: ActivityState;
    group: String;
}

export interface PageLoadPerformanceMetrics {
    sectionThreeTotalLoadDuration: Counter;
    sectionFiveDataLoadDuration: Counter;
    sectionTwoName: String;
    sectionTwoTotalLoadDuration: Counter;
    sectionFiveTotalLoadDuration: Counter;
    sectionOneName: String;
    sectionOneTotalLoadDuration: Counter;
    sectionFourDataLoadDuration: Counter;
    viewDataLoadDuration: Counter;
    viewName: GfnViewNames;
    sectionThreeDataLoadDuration: Counter;
    sectionThreeName: String;
    sectionFourName: String;
    sectionTwoDataLoadDuration: Counter;
    sectionFiveName: String;
    sectionOneDataLoadDuration: Counter;
    sectionFourTotalLoadDuration: Counter;
    totalViewLoadDuration: Counter;
    imageLoadDuration: Counter;
    imageTransferSize: Counter;
    imageCount: Counter;
    usedJsHeapSize: Counter;
}

export interface SettingState {
    clientType: ClientType;
    settingValue: InfoString;
    settingLabel: InfoString;
    errorDetails: ErrorMessage;
}

export interface DeeplinkShare {
    queryParamsString: String;
    serviceName: String;
    error: DeeplinkError;
    shareType: DeeplinkShareType;
}

export interface Game_Launch_Metrics {
    lbrDuration: Counter;
    initialLaunchDuration: Counter;
    totalLaunchDuration: Counter;
    platformSelectionDuration: Counter;
    accountLinkingDuration: Counter;
    nesAuthorizationDuration: Counter;
    geronimoLaunchDuration: Counter;
    manualLoginEntryDuration: Counter;
    lbrRun: BooleanType;
    resumeType: GameResumeType;
    networkTestDuration: Counter;
    wasStartedWithResume: BooleanType;
    isResume: BooleanType;
    networkTestUiResult: NetworkTestUIResult;
    accountLinked: BooleanType;
    overrideActive: BooleanType;
    sessionCleanupDuration: Counter;
    sessionQueueDuration: Counter;
    autoLoginDuration: Counter;
    streamerCefStartupDuration: Counter;
    networkTestRun: BooleanType;
    gameLaunchSource: GameLaunchSourceType;
    oobeShown: BooleanType;
    isWarmLaunch: BooleanType;
    streamerJsStartupDuration: Counter;
    sessionId: IdString;
    oobeCheckDuration: Counter;
    startSessionDuration: Counter;
    overrideZone: InfoString;
    isFromGameChangeDialog: BooleanType;
    gameShortName: String;
    updateCheckDuration: Counter;
    status: EventStatus;
    errorDetails: ErrorMessage;
    streamerClientSetupDuration: Counter;
    streamerConnectionDuration: Counter;
    seatConfigDuration: Counter;
    streamingStartDuration: Counter;
    featuresState: FeatureState[];
    accountLinks: String[];
    remainingPlaytimeState: RemainingPlayTimeState;
    storeName: String;
    idleTimeout: Uint32;
}

export interface NetworkTest_Http_Event {
    networkSessionId: String;
    callDuration: Counter;
    requestStatusCode: String;
    requestId: IdString;
    verb: HTTPVerb;
    serverId: IdString;
    url: URLString;
    statusCode: String;
}

export interface GalleryAction {
    userAction: GalleryUserAction;
}

export interface GFNPCLogsInfo {
    totalSizeInBytes: Uint32;
    streamEndedWithNetworkError: BooleanType;
    uploadResult: String;
    streamSessionId: IdString;
    fileCount: Uint32;
}

export interface CTATileClickEvent {
    userAction: SyncCTATileUserAction;
}

export interface StreamingProfile {
    profileName: InfoString;
    framerate: Uint16;
    resolutionHeight: Uint16;
    maxBitrate: Float;
    aspectRatio: InfoString;
    resolutionWidth: Uint16;
    vSyncSetting: VSyncMode;
    streamingProfileGuid: String;
    hdrStreamingMode: HDRStreamingMode;
    reflexEnabled: BooleanType;
    cloudGsyncEnabled: BooleanType;
    inGameGraphicsSetting: BooleanType;
    audioChannelCount: Uint16;
    l4sEnabled: BooleanType;
    bitDepth: Uint16;
    dynamicStreamingMode: Uint16;
    chromaFormat: String;
    prefilteringMode: String;
    prefilterSharpness: Uint16;
    prefilterDenoise: Uint16;
    displayDpi: Uint16;
    fallbackToLogicalResolution: BooleanType;
    hudStreamingMode: Uint16;
    codec: String;
    dlssSrMode: Uint16;
    dlssSrModel: Uint16;
    dlssSrScale: Uint16;
    dlssRrModel: Uint16;
    dlssFgMode: Uint16;
    dlssFgModel: Uint16;
    dlssFgMultiplier: Uint16;
}

export interface ClientImeInteractionEvent {
    button: ClientIMEButtonEnum;
}

export interface StreamNowButtonClick {
    cmsId: String;
    originalAuthMethod: GFNSDKAuthType;
    timeRemaining: Counter;
    gfnSDKVersion: String;
    originalTimestamp: Counter;
    hasPartnerData: TelemetryBoolean;
    hasPartnerSecureData: TelemetryBoolean;
    originalCmsId: String;
    timeTaken: Counter;
    gameShortName: String;
    gfnDLLVersion: String;
    status: String;
    originalSource: String;
    originalShortname: String;
}

export interface HighlightCapture {
    modsActive: TelemetryBoolean;
    cmsId: String;
    clientHost: ClientHost;
    videoLengthMs: Counter;
    sdkVersion: String;
    highlightId: String;
    sessionId: String;
    shortName: String;
    contentType: ContentType;
}

export interface GalleryFileRemoved {
    cmsId: String;
    clientHost: ClientHost;
    highlightId: String;
    sessionId: String;
    shortName: String;
    contentType: ContentType;
}

export interface GalleryFilterEvent {
    item: String;
    cmsId: Int32;
    filtered: BooleanType;
    type: GalleryFilterType;
}

export interface MontageAction {
    userAction: MontageUserAction;
    timeSinceStart: Counter;
}

export interface UserSurvey {
    surveyId: String;
    surveyTrigger: SurveyTriggerType;
    hierarchy: String;
    durationMs: Counter;
    status: SurveyStatus;
}

export interface PluginAPIStatus {
    apiName: String;
    pluginName: PluginName;
    errorMessage: String;
    subApiName: String;
    status: APIStatus;
}

export interface GPUInfo {
    gpuProduct: String;
    gpuRevision: String;
    gpuBuildNumHi: String;
    gpuBuildNumLo: String;
    gpuDriverName: String;
    gpuDetails: GpuData[];
}

export interface GallerySortEvent {
    type: GallerySortType;
}

export interface OverrideKeyboardLayout {
    overrideKeyboardLayout: String;
    defaultKeyboardLayout: String;
    previousKeyboardLayout: String;
}

export interface Exception {
    exceptionTrace: ErrorMessage;
    fileName: InfoString;
    clientType: ClientType;
    name: ErrorMessage;
    message: ErrorMessage;
    stackFrameSource: InfoString;
}

export interface OpportunityViewStatus {
    cmsId: String;
    url: URLString;
    receipt: String;
    status: OpportunityStatus;
    durationInSec: Counter;
    watchedTimeInMs: Counter;
    pausedTimeInMs: Counter;
    errorInfo: String;
    currentScreenOrientation: Orientation;
    targetedAdsOptIn: BooleanType;
    sessionId: IdString;
    subSessionId: IdString;
    podId: IdString;
    adId: IdString;
    adSource: String;
    otherStateInfo: String;
}

export interface HighlightsCancelled {
    cmsId: String;
    clientHost: ClientHost;
    highlightId: String;
    sdkVersion: String;
    sessionId: String;
    shortName: String;
}

export interface GalleryAccess {
    cmsId: String;
    clientHost: ClientHost;
    numImages: Uint32;
    sessionId: String;
    contentMatchesCurrentGame: TelemetryBoolean;
    isCached: TelemetryBoolean;
    ageOfContent: Counter;
    numVideos: Uint32;
    highlightId: String;
    shortName: String;
    contentType: ContentType;
    navigationLevel: NavLevel;
    timeTakenMs: Counter;
}

export interface PushNotificationError {
    errorCategory: PushNotificationErrorCategory;
    projectId: String;
    errorDetails: ErrorMessage;
}

export interface PushNotificationPurgedEntries {
    deviceIds: String[];
    projectId: String;
}

export interface FreestyleStylesApplied {
    cmsId: String;
    activeStyle: Counter;
    activeFilters: String;
    style2Filters: String;
    persistedFilters: TelemetryBoolean;
    usedMenu: TelemetryBoolean;
    style1Filters: String;
    shortName: String;
    style3Filters: String;
    usedStyles: Counter;
}

export interface MediaPlay {
    streamSessionId: IdString;
    streamSubSessionId: IdString;
    mediaType: StreamingMediaType;
    result: MediaPlayResult;
    errorDetails: ErrorMessage;
    errorName: String;
    isResume: BooleanType;
    useCase: String;
}

export interface StatsClosedEvent {
    cmsId: String;
    shortName: String;
    clientHost: ClientHost;
    sessionId: String;
    totalMs: Int32;
    format: StatsFormat;
    position: ScreenPos;
}

export interface StatsViewChangedEvent {
    cmsId: String;
    shortName: String;
    clientHost: ClientHost;
    sessionId: String;
    format: StatsFormat;
    position: ScreenPos;
    uiOpen: TelemetryBoolean;
}

export interface GFNEventStatus {
    cmsId: String;
    streamSessionId: IdString;
    streamSubSessionId: IdString;
    eventType: GFNEventType;
    statusDetails: ErrorMessage;
}

export interface GameplayEntryEvent {
    cmsId: String;
    shortName: String;
    clientHost: ClientHost;
    sessionId: String;
    profile: String;
}

export interface StreamingQualityChangedEvent {
    cmsId: String;
    shortName: String;
    clientHost: ClientHost;
    sessionId: String;
    maxBitrateAuto: TelemetryBoolean;
    maxBitrateAutoChanged: TelemetryBoolean;
    maxBitrate: Counter;
    maxBitrateChanged: TelemetryBoolean;
    vsync: Counter;
    vsyncChanged: TelemetryBoolean;
    drc: TelemetryBoolean;
    drcChanged: TelemetryBoolean;
}

export interface ResolutionUpscalingChangedEvent {
    cmsId: String;
    shortName: String;
    clientHost: ClientHost;
    sessionId: String;
    upscaleMode: Counter;
    detailEnhancement: Counter;
}

export interface WidgetViewChangedEvent {
    cmsId: String;
    shortName: String;
    clientHost: ClientHost;
    sessionId: String;
    indicator: OsdHudIndicators;
    position: ScreenPos;
}

export interface NotificationChangedEvent {
    cmsId: String;
    shortName: String;
    clientHost: ClientHost;
    sessionId: String;
    control: IgoNotificationControls;
    state: TelemetryBoolean;
}

export interface PlaytesterSessionEvent {
    userAction: PlaytesterActionType;
    status: PlaytesterActionStatus;
    sessionId: String;
    streamSessionId: IdString;
    gameDeveloperName: String;
    gameName: String;
    gameBuildNumber: String;
    cmsId: String;
    webcamName: String;
    microphoneName: String;
    microphoneTested: TelemetryBoolean;
    errorInfo: String;
}

export interface ClipboardPasteEvent {
    clientClipboardRead: BooleanType;
    clipboardDataSent: BooleanType;
    clipboardDataLength: Counter;
    streamSessionId: IdString;
    streamSubSessionId: IdString;
    requestId: IdString;
}

export interface StorageUsageMetrics {
    totalQuota: Counter;
    totalUsage: Counter;
    cacheUsage: Counter;
    indexedDBUsage: Counter;
    serviceWorkerRegistrationsUsage: Counter;
}

export interface LoginStart {
    loginProviderIdpId: String;
}

export interface RemoteConfigInfo {
    isFetchedFromGXT: BooleanType;
    isLive: BooleanType;
    isSuccess: BooleanType;
    regionName: String;
    zoneName: String;
    project: String;
    product: String;
    revision: String;
}

export interface GameCampaignsUpdate {
    trigger: GameCampaignsUpdateTrigger;
    activeCampaignIds: String[];
    deActiveCampaignIds: String[];
}

export interface UDSDialogShown {
    sessionId: String;
    subSessionId: String;
    isSuccess: BooleanType;
    apiVersion: String;
    error: String;
    category: String;
    udsData: String;
    source: UDSTriggerSource;
}

export interface UDSSuggestionFeedback {
    sessionId: String;
    subSessionId: String;
    wasHelpful: TelemetryBoolean;
    apiVersion: String;
    snooze: BooleanType;
    showMore: BooleanType;
    learnMore: BooleanType;
    source: UDSTriggerSource;
    linkIdsClicked: String[];
}

export interface PluginLoads {
    pluginName: String;
    loadDurationMs: Counter;
    status: EventStatus;
}

export interface ClientSelfUpdate {
    category: SelfUpdateCategory;
    action: SelfUpdateAction;
    errorDetails: String;
    status: EventStatus;
    newVersion: String;
}

export interface UserWindowInfo {
    windowInnerHeight: Double;
    windowInnerWidth: Double;
    visualViewportHeight: Double;
    visualViewportWidth: Double;
    screenOrientationType: Orientation;
    devicePixelRatio: Double;
}

export interface ResourceLoadError {
    type: ResourceType;
    url: string;
    hierarchy: string;
    error: string;
    actionLabel: string;
}

export interface OwnershipFlowEvent {
    gameId: String;
    gameShortName: String;
    gameType: OwnershipFlowGameType;
    isMultiplatform: BooleanType;
    entryPoint: OwnershipFlowEntryPoint;
    accountsAutoResynced: String[];
    statesVisited: OwnershipFlowState[];
    lastState: OwnershipFlowState;
    flowEnd: OwnershipFlowEnd;
    ownershipType: GameOwnershipType;
    ownershipMethod: GameOwnershipMethod;
    selectedPlatformId: String;
    primaryConnectionAdded: String;
    secondaryConnectionAdded: String;
}

/////// Array Declarations ////////

/////// Event Type Declarations ////////
export const EventTypes = {
    CaptureEvent: {
        name: 'CaptureEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GalleryContentEvent: {
        name: 'GalleryContentEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    ClientAudioError: {
        name: 'ClientAudioError',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    AnselFreestyleError: {
        name: 'AnselFreestyleError',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    HighlightsGameSetting: {
        name: 'HighlightsGameSetting',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    TextSearch: {
        name: 'TextSearch',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    },
    ProcessStarted: {
        name: 'ProcessStarted',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    MicrophoneSettingChange: {
        name: 'MicrophoneSettingChange',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    MicrophoneInitialized: {
        name: 'MicrophoneInitialized',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    CheckGFN: {
        name: 'CheckGFN',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    UIAction: {
        name: 'UIAction',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    QueueEtaUpgradeClicked: {
        name: 'QueueEtaUpgradeClicked',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    QueueEtaAddPlaytimeClicked: {
        name: 'QueueEtaAddPlaytimeClicked',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    AudioNotificationEvent: {
        name: 'AudioNotificationEvent',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    PopUpDialogClosed: {
        name: 'PopUpDialogClosed',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    NetworkTest_Exception_Event: {
        name: 'NetworkTest_Exception_Event',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    Game_Launch_Event: {
        name: 'Game_Launch_Event',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    Game_Quit_Event: {
        name: 'Game_Quit_Event',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    LaunchProcess: {
        name: 'LaunchProcess',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    ClientImeOpenEvent: {
        name: 'ClientImeOpenEvent',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    OpenedIGO: {
        name: 'OpenedIGO',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GalleryPlayedVideo: {
        name: 'GalleryPlayedVideo',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    },
    AnselFreestyleFeatureDisabled: {
        name: 'AnselFreestyleFeatureDisabled',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    SettingSnapshot: {
        name: 'SettingSnapshot',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    },
    Application_Install: {
        name: 'Application_Install',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    QueueAbandoned: {
        name: 'QueueAbandoned',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    OwnershipSyncEvent: {
        name: 'OwnershipSyncEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    PopUpDialogShown: {
        name: 'PopUpDialogShown',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    PushNotificationReceived: {
        name: 'PushNotificationReceived',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    UITransition: {
        name: 'UITransition',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    },
    OOBE_Accept: {
        name: 'OOBE_Accept',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    RoutingStatus: {
        name: 'RoutingStatus',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    CrashInfo: {
        name: 'CrashInfo',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    HTTPFailure: {
        name: 'HTTPFailure',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    AnselFreestyleSession: {
        name: 'AnselFreestyleSession',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    PushNotificationTokenRegistered: {
        name: 'PushNotificationTokenRegistered',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    AutoUpdate: {
        name: 'AutoUpdate',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    LayoutTelemetry: {
        name: 'LayoutTelemetry',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    BrowserClientCanary: {
        name: 'BrowserClientCanary',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    HTTPSuccess: {
        name: 'HTTPSuccess',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    HTTPCallResult: {
        name: 'HTTPCallResult',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    SDKCallResult: {
        name: 'SDKCallResult',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    IgoShortcuts: {
        name: 'IgoShortcuts',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    Drag: {
        name: 'Drag',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    HighlightsIndividualGameToggle: {
        name: 'HighlightsIndividualGameToggle',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    },
    NetworkTest: {
        name: 'NetworkTest',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GFNSession: {
        name: 'GFNSession',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    DeeplinkSource: {
        name: 'DeeplinkSource',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    HIDInfo: {
        name: 'HIDInfo',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    SystemInfo: {
        name: 'SystemInfo',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GameSearchFilterEvent: {
        name: 'GameSearchFilterEvent',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    },
    GalleryOpenedFileLocation: {
        name: 'GalleryOpenedFileLocation',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    },
    Click: {
        name: 'Click',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    AnselFreestyleFilters: {
        name: 'AnselFreestyleFilters',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GalleryFilterUsed: {
        name: 'GalleryFilterUsed',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    },
    UserSession: {
        name: 'UserSession',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    NavigationPerformanceMetrics: {
        name: 'NavigationPerformanceMetrics',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    GalleryDeleteCountEvent: {
        name: 'GalleryDeleteCountEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    MontageEvent: {
        name: 'MontageEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    CreateHTTPServerError: {
        name: 'CreateHTTPServerError',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    AnselScreenshotEvent: {
        name: 'AnselScreenshotEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    Hit_Event: {
        name: 'Hit_Event',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    CloudSearch: {
        name: 'CloudSearch',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    AuthenticationProvider: {
        name: 'AuthenticationProvider',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    ExperienceControlInfo: {
        name: 'ExperienceControlInfo',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    PageLoadPerformanceMetrics: {
        name: 'PageLoadPerformanceMetrics',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    SettingState: {
        name: 'SettingState',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    DeeplinkShare: {
        name: 'DeeplinkShare',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    Game_Launch_Metrics: {
        name: 'Game_Launch_Metrics',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    NetworkTest_Http_Event: {
        name: 'NetworkTest_Http_Event',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GalleryAction: {
        name: 'GalleryAction',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GFNPCLogsInfo: {
        name: 'GFNPCLogsInfo',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    CTATileClickEvent: {
        name: 'CTATileClickEvent',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    StreamingProfile: {
        name: 'StreamingProfile',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    ClientImeInteractionEvent: {
        name: 'ClientImeInteractionEvent',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    StreamNowButtonClick: {
        name: 'StreamNowButtonClick',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    HighlightCapture: {
        name: 'HighlightCapture',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GalleryFileRemoved: {
        name: 'GalleryFileRemoved',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    },
    GalleryFilterEvent: {
        name: 'GalleryFilterEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    MontageAction: {
        name: 'MontageAction',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    UserSurvey: {
        name: 'UserSurvey',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    PluginAPIStatus: {
        name: 'PluginAPIStatus',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    GPUInfo: {
        name: 'GPUInfo',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GallerySortEvent: {
        name: 'GallerySortEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    OverrideKeyboardLayout: {
        name: 'OverrideKeyboardLayout',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    Exception: {
        name: 'Exception',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    OpportunityViewStatus: {
        name: 'OpportunityViewStatus',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    HighlightsCancelled: {
        name: 'HighlightsCancelled',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GalleryAccess: {
        name: 'GalleryAccess',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    PushNotificationError: {
        name: 'PushNotificationError',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    PushNotificationPurgedEntries: {
        name: 'PushNotificationPurgedEntries',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    FreestyleStylesApplied: {
        name: 'FreestyleStylesApplied',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    MediaPlay: {
        name: 'MediaPlay',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    StatsClosedEvent: {
        name: 'StatsClosedEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    StatsViewChangedEvent: {
        name: 'StatsViewChangedEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GFNEventStatus: {
        name: 'GFNEventStatus',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GameplayEntryEvent: {
        name: 'GameplayEntryEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    StreamingQualityChangedEvent: {
        name: 'StreamingQualityChangedEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    ResolutionUpscalingChangedEvent: {
        name: 'ResolutionUpscalingChangedEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    WidgetViewChangedEvent: {
        name: 'WidgetViewChangedEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    NotificationChangedEvent: {
        name: 'NotificationChangedEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    PlaytesterSessionEvent: {
        name: 'PlaytesterSessionEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    ClipboardPasteEvent: {
        name: 'ClipboardPasteEvent',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    StorageUsageMetrics: {
        name: 'StorageUsageMetrics',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    LoginStart: {
        name: 'LoginStart',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    RemoteConfigInfo: {
        name: 'RemoteConfigInfo',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    GameCampaignsUpdate: {
        name: 'GameCampaignsUpdate',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    UDSDialogShown: {
        name: 'UDSDialogShown',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    UDSSuggestionFeedback: {
        name: 'UDSSuggestionFeedback',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    PluginLoads: {
        name: 'PluginLoads',
        gdprLevel: GdprLevel.Technical,
        personalization: Personalization.UserPreferred
    },
    ClientSelfUpdate: {
        name: 'ClientSelfUpdate',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    UserWindowInfo: {
        name: 'UserWindowInfo',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    ResourceLoadError: {
        name: 'ResourceLoadError',
        gdprLevel: GdprLevel.Functional,
        personalization: Personalization.UserPreferred
    },
    OwnershipFlowEvent: {
        name: 'OwnershipFlowEvent',
        gdprLevel: GdprLevel.Behavioral,
        personalization: Personalization.UserPreferred
    }
};

/////// Event Class Declarations ////////
export class TelemetryEvent<T> {
    readonly name: string;
    readonly gdprLevel: GdprLevel;
    readonly ts;
    personalization: Personalization;
    parameters: T;
    constructor(info: T) {
        this.parameters = info;
        this.ts = new Date().toISOString();
    }
}

export class CaptureEventDef extends TelemetryEvent<CaptureEvent> {
    readonly name: string = EventTypes.CaptureEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.CaptureEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.CaptureEvent.personalization;
    constructor(info: CaptureEvent) {
        super(info);
    }
}

export class GalleryContentEventDef extends TelemetryEvent<GalleryContentEvent> {
    readonly name: string = EventTypes.GalleryContentEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.GalleryContentEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.GalleryContentEvent.personalization;
    constructor(info: GalleryContentEvent) {
        super(info);
    }
}

export class ClientAudioErrorDef extends TelemetryEvent<ClientAudioError> {
    readonly name: string = EventTypes.ClientAudioError.name;
    readonly gdprLevel: GdprLevel = EventTypes.ClientAudioError.gdprLevel;
    readonly personalization: Personalization = EventTypes.ClientAudioError.personalization;
    constructor(info: ClientAudioError) {
        super(info);
    }
}

export class AnselFreestyleErrorDef extends TelemetryEvent<AnselFreestyleError> {
    readonly name: string = EventTypes.AnselFreestyleError.name;
    readonly gdprLevel: GdprLevel = EventTypes.AnselFreestyleError.gdprLevel;
    readonly personalization: Personalization = EventTypes.AnselFreestyleError.personalization;
    constructor(info: AnselFreestyleError) {
        super(info);
    }
}

export class HighlightsGameSettingDef extends TelemetryEvent<HighlightsGameSetting> {
    readonly name: string = EventTypes.HighlightsGameSetting.name;
    readonly gdprLevel: GdprLevel = EventTypes.HighlightsGameSetting.gdprLevel;
    readonly personalization: Personalization = EventTypes.HighlightsGameSetting.personalization;
    constructor(info: HighlightsGameSetting) {
        super(info);
    }
}

export class TextSearchDef extends TelemetryEvent<TextSearch> {
    readonly name: string = EventTypes.TextSearch.name;
    readonly gdprLevel: GdprLevel = EventTypes.TextSearch.gdprLevel;
    readonly personalization: Personalization = EventTypes.TextSearch.personalization;
    constructor(info: TextSearch) {
        super(info);
    }
}

export class ProcessStartedDef extends TelemetryEvent<ProcessStarted> {
    readonly name: string = EventTypes.ProcessStarted.name;
    readonly gdprLevel: GdprLevel = EventTypes.ProcessStarted.gdprLevel;
    readonly personalization: Personalization = EventTypes.ProcessStarted.personalization;
    constructor(info: ProcessStarted) {
        super(info);
    }
}

export class MicrophoneSettingChangeDef extends TelemetryEvent<MicrophoneSettingChange> {
    readonly name: string = EventTypes.MicrophoneSettingChange.name;
    readonly gdprLevel: GdprLevel = EventTypes.MicrophoneSettingChange.gdprLevel;
    readonly personalization: Personalization = EventTypes.MicrophoneSettingChange.personalization;
    constructor(info: MicrophoneSettingChange) {
        super(info);
    }
}

export class MicrophoneInitializedDef extends TelemetryEvent<MicrophoneInitialized> {
    readonly name: string = EventTypes.MicrophoneInitialized.name;
    readonly gdprLevel: GdprLevel = EventTypes.MicrophoneInitialized.gdprLevel;
    readonly personalization: Personalization = EventTypes.MicrophoneInitialized.personalization;
    constructor(info: MicrophoneInitialized) {
        super(info);
    }
}

export class CheckGFNDef extends TelemetryEvent<CheckGFN> {
    readonly name: string = EventTypes.CheckGFN.name;
    readonly gdprLevel: GdprLevel = EventTypes.CheckGFN.gdprLevel;
    readonly personalization: Personalization = EventTypes.CheckGFN.personalization;
    constructor(info: CheckGFN) {
        super(info);
    }
}

export class UIActionDef extends TelemetryEvent<UIAction> {
    readonly name: string = EventTypes.UIAction.name;
    readonly gdprLevel: GdprLevel = EventTypes.UIAction.gdprLevel;
    readonly personalization: Personalization = EventTypes.UIAction.personalization;
    constructor(info: UIAction) {
        super(info);
    }
}

export class QueueEtaUpgradeClickedDef extends TelemetryEvent<QueueEtaUpgradeClicked> {
    readonly name: string = EventTypes.QueueEtaUpgradeClicked.name;
    readonly gdprLevel: GdprLevel = EventTypes.QueueEtaUpgradeClicked.gdprLevel;
    readonly personalization: Personalization = EventTypes.QueueEtaUpgradeClicked.personalization;
    constructor(info: QueueEtaUpgradeClicked) {
        super(info);
    }
}

export class QueueEtaAddPlaytimeClickedDef extends TelemetryEvent<QueueEtaAddPlaytimeClicked> {
    readonly name: string = EventTypes.QueueEtaAddPlaytimeClicked.name;
    readonly gdprLevel: GdprLevel = EventTypes.QueueEtaAddPlaytimeClicked.gdprLevel;
    readonly personalization: Personalization = EventTypes.QueueEtaAddPlaytimeClicked.personalization;
    constructor(info: QueueEtaAddPlaytimeClicked) {
        super(info);
    }
}

export class AudioNotificationEventDef extends TelemetryEvent<AudioNotificationEvent> {
    readonly name: string = EventTypes.AudioNotificationEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.AudioNotificationEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.AudioNotificationEvent.personalization;
    constructor(info: AudioNotificationEvent) {
        super(info);
    }
}

export class PopUpDialogClosedDef extends TelemetryEvent<PopUpDialogClosed> {
    readonly name: string = EventTypes.PopUpDialogClosed.name;
    readonly gdprLevel: GdprLevel = EventTypes.PopUpDialogClosed.gdprLevel;
    readonly personalization: Personalization = EventTypes.PopUpDialogClosed.personalization;
    constructor(info: PopUpDialogClosed) {
        super(info);
    }
}

export class NetworkTest_Exception_EventDef extends TelemetryEvent<NetworkTest_Exception_Event> {
    readonly name: string = EventTypes.NetworkTest_Exception_Event.name;
    readonly gdprLevel: GdprLevel = EventTypes.NetworkTest_Exception_Event.gdprLevel;
    readonly personalization: Personalization = EventTypes.NetworkTest_Exception_Event.personalization;
    constructor(info: NetworkTest_Exception_Event) {
        super(info);
    }
}

export class Game_Launch_EventDef extends TelemetryEvent<Game_Launch_Event> {
    readonly name: string = EventTypes.Game_Launch_Event.name;
    readonly gdprLevel: GdprLevel = EventTypes.Game_Launch_Event.gdprLevel;
    readonly personalization: Personalization = EventTypes.Game_Launch_Event.personalization;
    constructor(info: Game_Launch_Event) {
        super(info);
    }
}

export class Game_Quit_EventDef extends TelemetryEvent<Game_Quit_Event> {
    readonly name: string = EventTypes.Game_Quit_Event.name;
    readonly gdprLevel: GdprLevel = EventTypes.Game_Quit_Event.gdprLevel;
    readonly personalization: Personalization = EventTypes.Game_Quit_Event.personalization;
    constructor(info: Game_Quit_Event) {
        super(info);
    }
}

export class LaunchProcessDef extends TelemetryEvent<LaunchProcess> {
    readonly name: string = EventTypes.LaunchProcess.name;
    readonly gdprLevel: GdprLevel = EventTypes.LaunchProcess.gdprLevel;
    readonly personalization: Personalization = EventTypes.LaunchProcess.personalization;
    constructor(info: LaunchProcess) {
        super(info);
    }
}

export class ClientImeOpenEventDef extends TelemetryEvent<ClientImeOpenEvent> {
    readonly name: string = EventTypes.ClientImeOpenEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.ClientImeOpenEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.ClientImeOpenEvent.personalization;
    constructor(info: ClientImeOpenEvent) {
        super(info);
    }
}

export class OpenedIGODef extends TelemetryEvent<OpenedIGO> {
    readonly name: string = EventTypes.OpenedIGO.name;
    readonly gdprLevel: GdprLevel = EventTypes.OpenedIGO.gdprLevel;
    readonly personalization: Personalization = EventTypes.OpenedIGO.personalization;
    constructor(info: OpenedIGO) {
        super(info);
    }
}

export class GalleryPlayedVideoDef extends TelemetryEvent<GalleryPlayedVideo> {
    readonly name: string = EventTypes.GalleryPlayedVideo.name;
    readonly gdprLevel: GdprLevel = EventTypes.GalleryPlayedVideo.gdprLevel;
    readonly personalization: Personalization = EventTypes.GalleryPlayedVideo.personalization;
    constructor(info: GalleryPlayedVideo) {
        super(info);
    }
}

export class AnselFreestyleFeatureDisabledDef extends TelemetryEvent<AnselFreestyleFeatureDisabled> {
    readonly name: string = EventTypes.AnselFreestyleFeatureDisabled.name;
    readonly gdprLevel: GdprLevel = EventTypes.AnselFreestyleFeatureDisabled.gdprLevel;
    readonly personalization: Personalization = EventTypes.AnselFreestyleFeatureDisabled.personalization;
    constructor(info: AnselFreestyleFeatureDisabled) {
        super(info);
    }
}

export class SettingSnapshotDef extends TelemetryEvent<SettingSnapshot> {
    readonly name: string = EventTypes.SettingSnapshot.name;
    readonly gdprLevel: GdprLevel = EventTypes.SettingSnapshot.gdprLevel;
    readonly personalization: Personalization = EventTypes.SettingSnapshot.personalization;
    constructor(info: SettingSnapshot) {
        super(info);
    }
}

export class Application_InstallDef extends TelemetryEvent<Application_Install> {
    readonly name: string = EventTypes.Application_Install.name;
    readonly gdprLevel: GdprLevel = EventTypes.Application_Install.gdprLevel;
    readonly personalization: Personalization = EventTypes.Application_Install.personalization;
    constructor(info: Application_Install) {
        super(info);
    }
}

export class QueueAbandonedDef extends TelemetryEvent<QueueAbandoned> {
    readonly name: string = EventTypes.QueueAbandoned.name;
    readonly gdprLevel: GdprLevel = EventTypes.QueueAbandoned.gdprLevel;
    readonly personalization: Personalization = EventTypes.QueueAbandoned.personalization;
    constructor(info: QueueAbandoned) {
        super(info);
    }
}

export class OwnershipSyncEventDef extends TelemetryEvent<OwnershipSyncEvent> {
    readonly name: string = EventTypes.OwnershipSyncEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.OwnershipSyncEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.OwnershipSyncEvent.personalization;
    constructor(info: OwnershipSyncEvent) {
        super(info);
    }
}

export class PopUpDialogShownDef extends TelemetryEvent<PopUpDialogShown> {
    readonly name: string = EventTypes.PopUpDialogShown.name;
    readonly gdprLevel: GdprLevel = EventTypes.PopUpDialogShown.gdprLevel;
    readonly personalization: Personalization = EventTypes.PopUpDialogShown.personalization;
    constructor(info: PopUpDialogShown) {
        super(info);
    }
}

export class PushNotificationReceivedDef extends TelemetryEvent<PushNotificationReceived> {
    readonly name: string = EventTypes.PushNotificationReceived.name;
    readonly gdprLevel: GdprLevel = EventTypes.PushNotificationReceived.gdprLevel;
    readonly personalization: Personalization = EventTypes.PushNotificationReceived.personalization;
    constructor(info: PushNotificationReceived) {
        super(info);
    }
}

export class UITransitionDef extends TelemetryEvent<UITransition> {
    readonly name: string = EventTypes.UITransition.name;
    readonly gdprLevel: GdprLevel = EventTypes.UITransition.gdprLevel;
    readonly personalization: Personalization = EventTypes.UITransition.personalization;
    constructor(info: UITransition) {
        super(info);
    }
}

export class OOBE_AcceptDef extends TelemetryEvent<OOBE_Accept> {
    readonly name: string = EventTypes.OOBE_Accept.name;
    readonly gdprLevel: GdprLevel = EventTypes.OOBE_Accept.gdprLevel;
    readonly personalization: Personalization = EventTypes.OOBE_Accept.personalization;
    constructor(info: OOBE_Accept) {
        super(info);
    }
}

export class RoutingStatusDef extends TelemetryEvent<RoutingStatus> {
    readonly name: string = EventTypes.RoutingStatus.name;
    readonly gdprLevel: GdprLevel = EventTypes.RoutingStatus.gdprLevel;
    readonly personalization: Personalization = EventTypes.RoutingStatus.personalization;
    constructor(info: RoutingStatus) {
        super(info);
    }
}

export class CrashInfoDef extends TelemetryEvent<CrashInfo> {
    readonly name: string = EventTypes.CrashInfo.name;
    readonly gdprLevel: GdprLevel = EventTypes.CrashInfo.gdprLevel;
    readonly personalization: Personalization = EventTypes.CrashInfo.personalization;
    constructor(info: CrashInfo) {
        super(info);
    }
}

export class HTTPFailureDef extends TelemetryEvent<HTTPFailure> {
    readonly name: string = EventTypes.HTTPFailure.name;
    readonly gdprLevel: GdprLevel = EventTypes.HTTPFailure.gdprLevel;
    readonly personalization: Personalization = EventTypes.HTTPFailure.personalization;
    constructor(info: HTTPFailure) {
        super(info);
    }
}

export class AnselFreestyleSessionDef extends TelemetryEvent<AnselFreestyleSession> {
    readonly name: string = EventTypes.AnselFreestyleSession.name;
    readonly gdprLevel: GdprLevel = EventTypes.AnselFreestyleSession.gdprLevel;
    readonly personalization: Personalization = EventTypes.AnselFreestyleSession.personalization;
    constructor(info: AnselFreestyleSession) {
        super(info);
    }
}

export class PushNotificationTokenRegisteredDef extends TelemetryEvent<PushNotificationTokenRegistered> {
    readonly name: string = EventTypes.PushNotificationTokenRegistered.name;
    readonly gdprLevel: GdprLevel = EventTypes.PushNotificationTokenRegistered.gdprLevel;
    readonly personalization: Personalization = EventTypes.PushNotificationTokenRegistered.personalization;
    constructor(info: PushNotificationTokenRegistered) {
        super(info);
    }
}

export class AutoUpdateDef extends TelemetryEvent<AutoUpdate> {
    readonly name: string = EventTypes.AutoUpdate.name;
    readonly gdprLevel: GdprLevel = EventTypes.AutoUpdate.gdprLevel;
    readonly personalization: Personalization = EventTypes.AutoUpdate.personalization;
    constructor(info: AutoUpdate) {
        super(info);
    }
}

export class LayoutTelemetryDef extends TelemetryEvent<LayoutTelemetry> {
    readonly name: string = EventTypes.LayoutTelemetry.name;
    readonly gdprLevel: GdprLevel = EventTypes.LayoutTelemetry.gdprLevel;
    readonly personalization: Personalization = EventTypes.LayoutTelemetry.personalization;
    constructor(info: LayoutTelemetry) {
        super(info);
    }
}

export class BrowserClientCanaryDef extends TelemetryEvent<BrowserClientCanary> {
    readonly name: string = EventTypes.BrowserClientCanary.name;
    readonly gdprLevel: GdprLevel = EventTypes.BrowserClientCanary.gdprLevel;
    readonly personalization: Personalization = EventTypes.BrowserClientCanary.personalization;
    constructor(info: BrowserClientCanary) {
        super(info);
    }
}

export class HTTPSuccessDef extends TelemetryEvent<HTTPSuccess> {
    readonly name: string = EventTypes.HTTPSuccess.name;
    readonly gdprLevel: GdprLevel = EventTypes.HTTPSuccess.gdprLevel;
    readonly personalization: Personalization = EventTypes.HTTPSuccess.personalization;
    constructor(info: HTTPSuccess) {
        super(info);
    }
}

export class HTTPCallResultDef extends TelemetryEvent<HTTPCallResult> {
    readonly name: string = EventTypes.HTTPCallResult.name;
    readonly gdprLevel: GdprLevel = EventTypes.HTTPCallResult.gdprLevel;
    readonly personalization: Personalization = EventTypes.HTTPCallResult.personalization;
    constructor(info: HTTPCallResult) {
        super(info);
    }
}

export class SDKCallResultDef extends TelemetryEvent<SDKCallResult> {
    readonly name: string = EventTypes.SDKCallResult.name;
    readonly gdprLevel: GdprLevel = EventTypes.SDKCallResult.gdprLevel;
    readonly personalization: Personalization = EventTypes.SDKCallResult.personalization;
    constructor(info: SDKCallResult) {
        super(info);
    }
}

export class IgoShortcutsDef extends TelemetryEvent<IgoShortcuts> {
    readonly name: string = EventTypes.IgoShortcuts.name;
    readonly gdprLevel: GdprLevel = EventTypes.IgoShortcuts.gdprLevel;
    readonly personalization: Personalization = EventTypes.IgoShortcuts.personalization;
    constructor(info: IgoShortcuts) {
        super(info);
    }
}

export class DragDef extends TelemetryEvent<Drag> {
    readonly name: string = EventTypes.Drag.name;
    readonly gdprLevel: GdprLevel = EventTypes.Drag.gdprLevel;
    readonly personalization: Personalization = EventTypes.Drag.personalization;
    constructor(info: Drag) {
        super(info);
    }
}

export class HighlightsIndividualGameToggleDef extends TelemetryEvent<HighlightsIndividualGameToggle> {
    readonly name: string = EventTypes.HighlightsIndividualGameToggle.name;
    readonly gdprLevel: GdprLevel = EventTypes.HighlightsIndividualGameToggle.gdprLevel;
    readonly personalization: Personalization = EventTypes.HighlightsIndividualGameToggle.personalization;
    constructor(info: HighlightsIndividualGameToggle) {
        super(info);
    }
}

export class NetworkTestDef extends TelemetryEvent<NetworkTest> {
    readonly name: string = EventTypes.NetworkTest.name;
    readonly gdprLevel: GdprLevel = EventTypes.NetworkTest.gdprLevel;
    readonly personalization: Personalization = EventTypes.NetworkTest.personalization;
    constructor(info: NetworkTest) {
        super(info);
    }
}

export class GFNSessionDef extends TelemetryEvent<GFNSession> {
    readonly name: string = EventTypes.GFNSession.name;
    readonly gdprLevel: GdprLevel = EventTypes.GFNSession.gdprLevel;
    readonly personalization: Personalization = EventTypes.GFNSession.personalization;
    constructor(info: GFNSession) {
        super(info);
    }
}

export class DeeplinkSourceDef extends TelemetryEvent<DeeplinkSource> {
    readonly name: string = EventTypes.DeeplinkSource.name;
    readonly gdprLevel: GdprLevel = EventTypes.DeeplinkSource.gdprLevel;
    readonly personalization: Personalization = EventTypes.DeeplinkSource.personalization;
    constructor(info: DeeplinkSource) {
        super(info);
    }
}

export class HIDInfoDef extends TelemetryEvent<HIDInfo> {
    readonly name: string = EventTypes.HIDInfo.name;
    readonly gdprLevel: GdprLevel = EventTypes.HIDInfo.gdprLevel;
    readonly personalization: Personalization = EventTypes.HIDInfo.personalization;
    constructor(info: HIDInfo) {
        super(info);
    }
}

export class SystemInfoDef extends TelemetryEvent<SystemInfo> {
    readonly name: string = EventTypes.SystemInfo.name;
    readonly gdprLevel: GdprLevel = EventTypes.SystemInfo.gdprLevel;
    readonly personalization: Personalization = EventTypes.SystemInfo.personalization;
    constructor(info: SystemInfo) {
        super(info);
    }
}

export class GameSearchFilterEventDef extends TelemetryEvent<GameSearchFilterEvent> {
    readonly name: string = EventTypes.GameSearchFilterEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.GameSearchFilterEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.GameSearchFilterEvent.personalization;
    constructor(info: GameSearchFilterEvent) {
        super(info);
    }
}

export class GalleryOpenedFileLocationDef extends TelemetryEvent<GalleryOpenedFileLocation> {
    readonly name: string = EventTypes.GalleryOpenedFileLocation.name;
    readonly gdprLevel: GdprLevel = EventTypes.GalleryOpenedFileLocation.gdprLevel;
    readonly personalization: Personalization = EventTypes.GalleryOpenedFileLocation.personalization;
    constructor(info: GalleryOpenedFileLocation) {
        super(info);
    }
}

export class ClickDef extends TelemetryEvent<Click> {
    readonly name: string = EventTypes.Click.name;
    readonly gdprLevel: GdprLevel = EventTypes.Click.gdprLevel;
    readonly personalization: Personalization = EventTypes.Click.personalization;
    constructor(info: Click) {
        super(info);
    }
}

export class AnselFreestyleFiltersDef extends TelemetryEvent<AnselFreestyleFilters> {
    readonly name: string = EventTypes.AnselFreestyleFilters.name;
    readonly gdprLevel: GdprLevel = EventTypes.AnselFreestyleFilters.gdprLevel;
    readonly personalization: Personalization = EventTypes.AnselFreestyleFilters.personalization;
    constructor(info: AnselFreestyleFilters) {
        super(info);
    }
}

export class GalleryFilterUsedDef extends TelemetryEvent<GalleryFilterUsed> {
    readonly name: string = EventTypes.GalleryFilterUsed.name;
    readonly gdprLevel: GdprLevel = EventTypes.GalleryFilterUsed.gdprLevel;
    readonly personalization: Personalization = EventTypes.GalleryFilterUsed.personalization;
    constructor(info: GalleryFilterUsed) {
        super(info);
    }
}

export class UserSessionDef extends TelemetryEvent<UserSession> {
    readonly name: string = EventTypes.UserSession.name;
    readonly gdprLevel: GdprLevel = EventTypes.UserSession.gdprLevel;
    readonly personalization: Personalization = EventTypes.UserSession.personalization;
    constructor(info: UserSession) {
        super(info);
    }
}

export class NavigationPerformanceMetricsDef extends TelemetryEvent<NavigationPerformanceMetrics> {
    readonly name: string = EventTypes.NavigationPerformanceMetrics.name;
    readonly gdprLevel: GdprLevel = EventTypes.NavigationPerformanceMetrics.gdprLevel;
    readonly personalization: Personalization = EventTypes.NavigationPerformanceMetrics.personalization;
    constructor(info: NavigationPerformanceMetrics) {
        super(info);
    }
}

export class GalleryDeleteCountEventDef extends TelemetryEvent<GalleryDeleteCountEvent> {
    readonly name: string = EventTypes.GalleryDeleteCountEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.GalleryDeleteCountEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.GalleryDeleteCountEvent.personalization;
    constructor(info: GalleryDeleteCountEvent) {
        super(info);
    }
}

export class MontageEventDef extends TelemetryEvent<MontageEvent> {
    readonly name: string = EventTypes.MontageEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.MontageEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.MontageEvent.personalization;
    constructor(info: MontageEvent) {
        super(info);
    }
}

export class CreateHTTPServerErrorDef extends TelemetryEvent<CreateHTTPServerError> {
    readonly name: string = EventTypes.CreateHTTPServerError.name;
    readonly gdprLevel: GdprLevel = EventTypes.CreateHTTPServerError.gdprLevel;
    readonly personalization: Personalization = EventTypes.CreateHTTPServerError.personalization;
    constructor(info: CreateHTTPServerError) {
        super(info);
    }
}

export class AnselScreenshotEventDef extends TelemetryEvent<AnselScreenshotEvent> {
    readonly name: string = EventTypes.AnselScreenshotEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.AnselScreenshotEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.AnselScreenshotEvent.personalization;
    constructor(info: AnselScreenshotEvent) {
        super(info);
    }
}

export class Hit_EventDef extends TelemetryEvent<Hit_Event> {
    readonly name: string = EventTypes.Hit_Event.name;
    readonly gdprLevel: GdprLevel = EventTypes.Hit_Event.gdprLevel;
    readonly personalization: Personalization = EventTypes.Hit_Event.personalization;
    constructor(info: Hit_Event) {
        super(info);
    }
}

export class CloudSearchDef extends TelemetryEvent<CloudSearch> {
    readonly name: string = EventTypes.CloudSearch.name;
    readonly gdprLevel: GdprLevel = EventTypes.CloudSearch.gdprLevel;
    readonly personalization: Personalization = EventTypes.CloudSearch.personalization;
    constructor(info: CloudSearch) {
        super(info);
    }
}

export class AuthenticationProviderDef extends TelemetryEvent<AuthenticationProvider> {
    readonly name: string = EventTypes.AuthenticationProvider.name;
    readonly gdprLevel: GdprLevel = EventTypes.AuthenticationProvider.gdprLevel;
    readonly personalization: Personalization = EventTypes.AuthenticationProvider.personalization;
    constructor(info: AuthenticationProvider) {
        super(info);
    }
}

export class ExperienceControlInfoDef extends TelemetryEvent<ExperienceControlInfo> {
    readonly name: string = EventTypes.ExperienceControlInfo.name;
    readonly gdprLevel: GdprLevel = EventTypes.ExperienceControlInfo.gdprLevel;
    readonly personalization: Personalization = EventTypes.ExperienceControlInfo.personalization;
    constructor(info: ExperienceControlInfo) {
        super(info);
    }
}

export class PageLoadPerformanceMetricsDef extends TelemetryEvent<PageLoadPerformanceMetrics> {
    readonly name: string = EventTypes.PageLoadPerformanceMetrics.name;
    readonly gdprLevel: GdprLevel = EventTypes.PageLoadPerformanceMetrics.gdprLevel;
    readonly personalization: Personalization = EventTypes.PageLoadPerformanceMetrics.personalization;
    constructor(info: PageLoadPerformanceMetrics) {
        super(info);
    }
}

export class SettingStateDef extends TelemetryEvent<SettingState> {
    readonly name: string = EventTypes.SettingState.name;
    readonly gdprLevel: GdprLevel = EventTypes.SettingState.gdprLevel;
    readonly personalization: Personalization = EventTypes.SettingState.personalization;
    constructor(info: SettingState) {
        super(info);
    }
}

export class DeeplinkShareDef extends TelemetryEvent<DeeplinkShare> {
    readonly name: string = EventTypes.DeeplinkShare.name;
    readonly gdprLevel: GdprLevel = EventTypes.DeeplinkShare.gdprLevel;
    readonly personalization: Personalization = EventTypes.DeeplinkShare.personalization;
    constructor(info: DeeplinkShare) {
        super(info);
    }
}

export class Game_Launch_MetricsDef extends TelemetryEvent<Game_Launch_Metrics> {
    readonly name: string = EventTypes.Game_Launch_Metrics.name;
    readonly gdprLevel: GdprLevel = EventTypes.Game_Launch_Metrics.gdprLevel;
    readonly personalization: Personalization = EventTypes.Game_Launch_Metrics.personalization;
    constructor(info: Game_Launch_Metrics) {
        super(info);
    }
}

export class NetworkTest_Http_EventDef extends TelemetryEvent<NetworkTest_Http_Event> {
    readonly name: string = EventTypes.NetworkTest_Http_Event.name;
    readonly gdprLevel: GdprLevel = EventTypes.NetworkTest_Http_Event.gdprLevel;
    readonly personalization: Personalization = EventTypes.NetworkTest_Http_Event.personalization;
    constructor(info: NetworkTest_Http_Event) {
        super(info);
    }
}

export class GalleryActionDef extends TelemetryEvent<GalleryAction> {
    readonly name: string = EventTypes.GalleryAction.name;
    readonly gdprLevel: GdprLevel = EventTypes.GalleryAction.gdprLevel;
    readonly personalization: Personalization = EventTypes.GalleryAction.personalization;
    constructor(info: GalleryAction) {
        super(info);
    }
}

export class GFNPCLogsInfoDef extends TelemetryEvent<GFNPCLogsInfo> {
    readonly name: string = EventTypes.GFNPCLogsInfo.name;
    readonly gdprLevel: GdprLevel = EventTypes.GFNPCLogsInfo.gdprLevel;
    readonly personalization: Personalization = EventTypes.GFNPCLogsInfo.personalization;
    constructor(info: GFNPCLogsInfo) {
        super(info);
    }
}

export class CTATileClickEventDef extends TelemetryEvent<CTATileClickEvent> {
    readonly name: string = EventTypes.CTATileClickEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.CTATileClickEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.CTATileClickEvent.personalization;
    constructor(info: CTATileClickEvent) {
        super(info);
    }
}

export class StreamingProfileDef extends TelemetryEvent<StreamingProfile> {
    readonly name: string = EventTypes.StreamingProfile.name;
    readonly gdprLevel: GdprLevel = EventTypes.StreamingProfile.gdprLevel;
    readonly personalization: Personalization = EventTypes.StreamingProfile.personalization;
    constructor(info: StreamingProfile) {
        super(info);
    }
}

export class ClientImeInteractionEventDef extends TelemetryEvent<ClientImeInteractionEvent> {
    readonly name: string = EventTypes.ClientImeInteractionEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.ClientImeInteractionEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.ClientImeInteractionEvent.personalization;
    constructor(info: ClientImeInteractionEvent) {
        super(info);
    }
}

export class StreamNowButtonClickDef extends TelemetryEvent<StreamNowButtonClick> {
    readonly name: string = EventTypes.StreamNowButtonClick.name;
    readonly gdprLevel: GdprLevel = EventTypes.StreamNowButtonClick.gdprLevel;
    readonly personalization: Personalization = EventTypes.StreamNowButtonClick.personalization;
    constructor(info: StreamNowButtonClick) {
        super(info);
    }
}

export class HighlightCaptureDef extends TelemetryEvent<HighlightCapture> {
    readonly name: string = EventTypes.HighlightCapture.name;
    readonly gdprLevel: GdprLevel = EventTypes.HighlightCapture.gdprLevel;
    readonly personalization: Personalization = EventTypes.HighlightCapture.personalization;
    constructor(info: HighlightCapture) {
        super(info);
    }
}

export class GalleryFileRemovedDef extends TelemetryEvent<GalleryFileRemoved> {
    readonly name: string = EventTypes.GalleryFileRemoved.name;
    readonly gdprLevel: GdprLevel = EventTypes.GalleryFileRemoved.gdprLevel;
    readonly personalization: Personalization = EventTypes.GalleryFileRemoved.personalization;
    constructor(info: GalleryFileRemoved) {
        super(info);
    }
}

export class GalleryFilterEventDef extends TelemetryEvent<GalleryFilterEvent> {
    readonly name: string = EventTypes.GalleryFilterEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.GalleryFilterEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.GalleryFilterEvent.personalization;
    constructor(info: GalleryFilterEvent) {
        super(info);
    }
}

export class MontageActionDef extends TelemetryEvent<MontageAction> {
    readonly name: string = EventTypes.MontageAction.name;
    readonly gdprLevel: GdprLevel = EventTypes.MontageAction.gdprLevel;
    readonly personalization: Personalization = EventTypes.MontageAction.personalization;
    constructor(info: MontageAction) {
        super(info);
    }
}

export class UserSurveyDef extends TelemetryEvent<UserSurvey> {
    readonly name: string = EventTypes.UserSurvey.name;
    readonly gdprLevel: GdprLevel = EventTypes.UserSurvey.gdprLevel;
    readonly personalization: Personalization = EventTypes.UserSurvey.personalization;
    constructor(info: UserSurvey) {
        super(info);
    }
}

export class PluginAPIStatusDef extends TelemetryEvent<PluginAPIStatus> {
    readonly name: string = EventTypes.PluginAPIStatus.name;
    readonly gdprLevel: GdprLevel = EventTypes.PluginAPIStatus.gdprLevel;
    readonly personalization: Personalization = EventTypes.PluginAPIStatus.personalization;
    constructor(info: PluginAPIStatus) {
        super(info);
    }
}

export class GPUInfoDef extends TelemetryEvent<GPUInfo> {
    readonly name: string = EventTypes.GPUInfo.name;
    readonly gdprLevel: GdprLevel = EventTypes.GPUInfo.gdprLevel;
    readonly personalization: Personalization = EventTypes.GPUInfo.personalization;
    constructor(info: GPUInfo) {
        super(info);
    }
}

export class GallerySortEventDef extends TelemetryEvent<GallerySortEvent> {
    readonly name: string = EventTypes.GallerySortEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.GallerySortEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.GallerySortEvent.personalization;
    constructor(info: GallerySortEvent) {
        super(info);
    }
}

export class OverrideKeyboardLayoutDef extends TelemetryEvent<OverrideKeyboardLayout> {
    readonly name: string = EventTypes.OverrideKeyboardLayout.name;
    readonly gdprLevel: GdprLevel = EventTypes.OverrideKeyboardLayout.gdprLevel;
    readonly personalization: Personalization = EventTypes.OverrideKeyboardLayout.personalization;
    constructor(info: OverrideKeyboardLayout) {
        super(info);
    }
}

export class ExceptionDef extends TelemetryEvent<Exception> {
    readonly name: string = EventTypes.Exception.name;
    readonly gdprLevel: GdprLevel = EventTypes.Exception.gdprLevel;
    readonly personalization: Personalization = EventTypes.Exception.personalization;
    constructor(info: Exception) {
        super(info);
    }
}

export class OpportunityViewStatusDef extends TelemetryEvent<OpportunityViewStatus> {
    readonly name: string = EventTypes.OpportunityViewStatus.name;
    readonly gdprLevel: GdprLevel = EventTypes.OpportunityViewStatus.gdprLevel;
    readonly personalization: Personalization = EventTypes.OpportunityViewStatus.personalization;
    constructor(info: OpportunityViewStatus) {
        super(info);
    }
}

export class HighlightsCancelledDef extends TelemetryEvent<HighlightsCancelled> {
    readonly name: string = EventTypes.HighlightsCancelled.name;
    readonly gdprLevel: GdprLevel = EventTypes.HighlightsCancelled.gdprLevel;
    readonly personalization: Personalization = EventTypes.HighlightsCancelled.personalization;
    constructor(info: HighlightsCancelled) {
        super(info);
    }
}

export class GalleryAccessDef extends TelemetryEvent<GalleryAccess> {
    readonly name: string = EventTypes.GalleryAccess.name;
    readonly gdprLevel: GdprLevel = EventTypes.GalleryAccess.gdprLevel;
    readonly personalization: Personalization = EventTypes.GalleryAccess.personalization;
    constructor(info: GalleryAccess) {
        super(info);
    }
}

export class PushNotificationErrorDef extends TelemetryEvent<PushNotificationError> {
    readonly name: string = EventTypes.PushNotificationError.name;
    readonly gdprLevel: GdprLevel = EventTypes.PushNotificationError.gdprLevel;
    readonly personalization: Personalization = EventTypes.PushNotificationError.personalization;
    constructor(info: PushNotificationError) {
        super(info);
    }
}

export class PushNotificationPurgedEntriesDef extends TelemetryEvent<PushNotificationPurgedEntries> {
    readonly name: string = EventTypes.PushNotificationPurgedEntries.name;
    readonly gdprLevel: GdprLevel = EventTypes.PushNotificationPurgedEntries.gdprLevel;
    readonly personalization: Personalization = EventTypes.PushNotificationPurgedEntries.personalization;
    constructor(info: PushNotificationPurgedEntries) {
        super(info);
    }
}

export class FreestyleStylesAppliedDef extends TelemetryEvent<FreestyleStylesApplied> {
    readonly name: string = EventTypes.FreestyleStylesApplied.name;
    readonly gdprLevel: GdprLevel = EventTypes.FreestyleStylesApplied.gdprLevel;
    readonly personalization: Personalization = EventTypes.FreestyleStylesApplied.personalization;
    constructor(info: FreestyleStylesApplied) {
        super(info);
    }
}

export class MediaPlayDef extends TelemetryEvent<MediaPlay> {
    readonly name: string = EventTypes.MediaPlay.name;
    readonly gdprLevel: GdprLevel = EventTypes.MediaPlay.gdprLevel;
    readonly personalization: Personalization = EventTypes.MediaPlay.personalization;
    constructor(info: MediaPlay) {
        super(info);
    }
}

export class StatsClosedEventDef extends TelemetryEvent<StatsClosedEvent> {
    readonly name: string = EventTypes.StatsClosedEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.StatsClosedEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.StatsClosedEvent.personalization;
    constructor(info: StatsClosedEvent) {
        super(info);
    }
}

export class StatsViewChangedEventDef extends TelemetryEvent<StatsViewChangedEvent> {
    readonly name: string = EventTypes.StatsViewChangedEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.StatsViewChangedEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.StatsViewChangedEvent.personalization;
    constructor(info: StatsViewChangedEvent) {
        super(info);
    }
}

export class GFNEventStatusDef extends TelemetryEvent<GFNEventStatus> {
    readonly name: string = EventTypes.GFNEventStatus.name;
    readonly gdprLevel: GdprLevel = EventTypes.GFNEventStatus.gdprLevel;
    readonly personalization: Personalization = EventTypes.GFNEventStatus.personalization;
    constructor(info: GFNEventStatus) {
        super(info);
    }
}

export class GameplayEntryEventDef extends TelemetryEvent<GameplayEntryEvent> {
    readonly name: string = EventTypes.GameplayEntryEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.GameplayEntryEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.GameplayEntryEvent.personalization;
    constructor(info: GameplayEntryEvent) {
        super(info);
    }
}

export class StreamingQualityChangedEventDef extends TelemetryEvent<StreamingQualityChangedEvent> {
    readonly name: string = EventTypes.StreamingQualityChangedEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.StreamingQualityChangedEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.StreamingQualityChangedEvent.personalization;
    constructor(info: StreamingQualityChangedEvent) {
        super(info);
    }
}

export class ResolutionUpscalingChangedEventDef extends TelemetryEvent<ResolutionUpscalingChangedEvent> {
    readonly name: string = EventTypes.ResolutionUpscalingChangedEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.ResolutionUpscalingChangedEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.ResolutionUpscalingChangedEvent.personalization;
    constructor(info: ResolutionUpscalingChangedEvent) {
        super(info);
    }
}

export class WidgetViewChangedEventDef extends TelemetryEvent<WidgetViewChangedEvent> {
    readonly name: string = EventTypes.WidgetViewChangedEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.WidgetViewChangedEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.WidgetViewChangedEvent.personalization;
    constructor(info: WidgetViewChangedEvent) {
        super(info);
    }
}

export class NotificationChangedEventDef extends TelemetryEvent<NotificationChangedEvent> {
    readonly name: string = EventTypes.NotificationChangedEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.NotificationChangedEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.NotificationChangedEvent.personalization;
    constructor(info: NotificationChangedEvent) {
        super(info);
    }
}

export class PlaytesterSessionEventDef extends TelemetryEvent<PlaytesterSessionEvent> {
    readonly name: string = EventTypes.PlaytesterSessionEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.PlaytesterSessionEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.PlaytesterSessionEvent.personalization;
    constructor(info: PlaytesterSessionEvent) {
        super(info);
    }
}

export class ClipboardPasteEventDef extends TelemetryEvent<ClipboardPasteEvent> {
    readonly name: string = EventTypes.ClipboardPasteEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.ClipboardPasteEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.ClipboardPasteEvent.personalization;
    constructor(info: ClipboardPasteEvent) {
        super(info);
    }
}

export class StorageUsageMetricsDef extends TelemetryEvent<StorageUsageMetrics> {
    readonly name: string = EventTypes.StorageUsageMetrics.name;
    readonly gdprLevel: GdprLevel = EventTypes.StorageUsageMetrics.gdprLevel;
    readonly personalization: Personalization = EventTypes.StorageUsageMetrics.personalization;
    constructor(info: StorageUsageMetrics) {
        super(info);
    }
}

export class LoginStartDef extends TelemetryEvent<LoginStart> {
    readonly name: string = EventTypes.LoginStart.name;
    readonly gdprLevel: GdprLevel = EventTypes.LoginStart.gdprLevel;
    readonly personalization: Personalization = EventTypes.LoginStart.personalization;
    constructor(info: LoginStart) {
        super(info);
    }
}

export class RemoteConfigInfoDef extends TelemetryEvent<RemoteConfigInfo> {
    readonly name: string = EventTypes.RemoteConfigInfo.name;
    readonly gdprLevel: GdprLevel = EventTypes.RemoteConfigInfo.gdprLevel;
    readonly personalization: Personalization = EventTypes.RemoteConfigInfo.personalization;
    constructor(info: RemoteConfigInfo) {
        super(info);
    }
}

export class GameCampaignsUpdateDef extends TelemetryEvent<GameCampaignsUpdate> {
    readonly name: string = EventTypes.GameCampaignsUpdate.name;
    readonly gdprLevel: GdprLevel = EventTypes.GameCampaignsUpdate.gdprLevel;
    readonly personalization: Personalization = EventTypes.GameCampaignsUpdate.personalization;
    constructor(info: GameCampaignsUpdate) {
        super(info);
    }
}

export class UDSDialogShownDef extends TelemetryEvent<UDSDialogShown> {
    readonly name: string = EventTypes.UDSDialogShown.name;
    readonly gdprLevel: GdprLevel = EventTypes.UDSDialogShown.gdprLevel;
    readonly personalization: Personalization = EventTypes.UDSDialogShown.personalization;
    constructor(info: UDSDialogShown) {
        super(info);
    }
}

export class UDSSuggestionFeedbackDef extends TelemetryEvent<UDSSuggestionFeedback> {
    readonly name: string = EventTypes.UDSSuggestionFeedback.name;
    readonly gdprLevel: GdprLevel = EventTypes.UDSSuggestionFeedback.gdprLevel;
    readonly personalization: Personalization = EventTypes.UDSSuggestionFeedback.personalization;
    constructor(info: UDSSuggestionFeedback) {
        super(info);
    }
}

export class PluginLoadsDef extends TelemetryEvent<PluginLoads> {
    readonly name: string = EventTypes.PluginLoads.name;
    readonly gdprLevel: GdprLevel = EventTypes.PluginLoads.gdprLevel;
    readonly personalization: Personalization = EventTypes.PluginLoads.personalization;
    constructor(info: PluginLoads) {
        super(info);
    }
}

export class ClientSelfUpdateDef extends TelemetryEvent<ClientSelfUpdate> {
    readonly name: string = EventTypes.ClientSelfUpdate.name;
    readonly gdprLevel: GdprLevel = EventTypes.ClientSelfUpdate.gdprLevel;
    readonly personalization: Personalization = EventTypes.ClientSelfUpdate.personalization;
    constructor(info: ClientSelfUpdate) {
        super(info);
    }
}

export class UserWindowInfoDef extends TelemetryEvent<UserWindowInfo> {
    readonly name: string = EventTypes.UserWindowInfo.name;
    readonly gdprLevel: GdprLevel = EventTypes.UserWindowInfo.gdprLevel;
    readonly personalization: Personalization = EventTypes.UserWindowInfo.personalization;
    constructor(info: UserWindowInfo) {
        super(info);
    }
}

export class ResourceLoadErrorDef extends TelemetryEvent<ResourceLoadError> {
    readonly name: string = EventTypes.ResourceLoadError.name;
    readonly gdprLevel: GdprLevel = EventTypes.ResourceLoadError.gdprLevel;
    readonly personalization: Personalization = EventTypes.ResourceLoadError.personalization;
    constructor(info: ResourceLoadError) {
        super(info);
    }
}

export class OwnershipFlowEventDef extends TelemetryEvent<OwnershipFlowEvent> {
    readonly name: string = EventTypes.OwnershipFlowEvent.name;
    readonly gdprLevel: GdprLevel = EventTypes.OwnershipFlowEvent.gdprLevel;
    readonly personalization: Personalization = EventTypes.OwnershipFlowEvent.personalization;
    constructor(info: OwnershipFlowEvent) {
        super(info);
    }
}
